// This file is automatically generated.
// Do not edit this file manually, use the script createLocales.js!

/* eslint-disable quotes */
/* eslint-disable indent */

export default {
  "__vendor__": "mtf",
  "devise": {
    "failure": {
      "bad_request": "Es wurden fehlerhafte Daten übermittelt. Bitte versuchen Sie es erneut.",
      "already_registered": "Diese E-Mail-Adresse ist bereits registriert. Zur Aktivierung Ihres Benutzerkontos wurde Ihnen eine Aktivierungs-E-Mail gesendet. Bitte überprüfen Sie Ihr E-Mail-Postfach und aktivieren Sie Ihr Konto.",
      "timeout": "Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an.",
      "forbidden": "Verboten",
      "invalid": "Ungültige Anmeldedaten.",
      "username": {
        "already_in_use": "Dieser Benutzername ist bereits vergeben!"
      },
      "email": {
        "already_in_use": "Diese E-Mail-Adresse ist bereits vergeben!"
      },
      "already_activated": "Falls Ihre E-Mail-Adresse in unserer Datenbank existiert, erhalten Sie in wenigen Minuten eine E-Mail mit der Anleitung, wie Sie Ihr Passwort zurücksetzen können."
    },
    "mailer": {
      "confirmation_instructions": {
        "subject": "Bitte bestätigen Sie Ihr DVM-Cloud-Service-Benutzerkonto "
      },
      "reset_password_instructions": {
        "subject": "Zurücksetzen Ihres Passworts"
      }
    },
    "confirmations": {
      "send_instructions": "Sie erhalten in wenigen Minuten eine E-Mail, mit der Sie Ihre Registrierung bestätigen können.",
      "send_instructions_paranoid": "Wenn Sie sich bei DVM Cloud Service registriert haben, erhalten Sie in wenigen Minuten eine E-Mail, mit der Sie Ihre Registrierung bestätigen können. Bitte überprüfen Sie Ihr E-Mail-Postfach."
    },
    "passwords": {
      "updated_not_active": "Ihr Passwort wurde geändert.",
      "send_paranoid_instructions": "Falls Ihre E-Mail-Adresse in unserer Datenbank existiert, erhalten Sie in wenigen Minuten eine E-Mail mit der Anleitung, wie Sie Ihr Passwort zurücksetzen können."
    },
    "registrations": {
      "destroyed": "Ihr Account wurde gelöscht."
    }
  },
  "general": {
    "welcome": "Willkommen",
    "yourProAccount": "Ihr DVM-Cloud-Service-Fachpartner-Zugang",
    "hello": "Hallo",
    "greetings": "Mit freundlichen Grüßen",
    "vbusnetTeam": "Ihr DVM-Cloud-Service-Team",
    "errorInvalidCharacters": "Ungültige Zeichen",
    "emailUnsubscribed": "Ihre E-Mail-Adresse wurde erfolgreich entfernt.",
    "emailAlreadyUnsubscribed": "Ihre E-Mail-Adresse wurde bereits entfernt.",
    "newDevice": "Neues Gerät",
    "isFriend": "Teilen",
    "backup": {
      "error": {
        "file": "Sicherungsdatei ungültig oder beschädigt!",
        "fileMatchSystem": "Sicherungsdatei passt nicht zum ausgewählten System"
      },
      "choose": {
        "file": "Backup-Datei auswählen…"
      },
      "restore": "Sicherung wiederherstellen",
      "successful": "Ihre Daten wurden erfolgreich wiederhergestellt.",
      "name": "Sicherung",
      "create": "Sicherung erstellen",
      "text1": "Hier finden Sie eine Übersicht Ihrer Daten. Wählen Sie die gewünschten Punkte aus, die gesichert werden sollen. Wenn Sie ein Live-System, Diagramm oder Download auswählen, werden die zugehörigen Filter und Bilder mitgesichert.",
      "file": "Backup-Datei",
      "text2": "Nachfolgend sind alle in der Sicherung befindlichen Daten aufgelistet. Sie können alle Daten oder nur ausgewählte Daten wiederherstellen. Wenn Sie ein Live-System, Diagramm oder Download auswählen, werden die zugehörigen Filter und Bilder ebenfalls wiederhergestellt.",
      "fileType": "Die Datei muss eine gültige DVM-Cloud-Service-Sicherungsdatei sein!",
      "text3": "Ihre Live-Daten haben sich seit Erstellung der Sicherung geändert! Dies kommt vor, wenn neue Geräte angeschlossen, vorhandene Geräte entfernt oder umverdrahtet wurden. Bitte beachten Sie, dass bei einer Rücksicherung möglicherweise die Zuordnung Ihrer Filter nicht mehr richtig ist.",
      "visualization": "Sicherung Visualisierungsdaten"
    },
    "days": "Tage",
    "entryNotFound": "Es wurde kein Eintrag gefunden.",
    "allValues": "Alle Werte",
    "unknown": "Unbekannt",
    "from": "von",
    "to": "bis",
    "customRange": "eigener Zeitraum",
    "name": "Name",
    "unit": "Einheit",
    "color": "Farbe",
    "format": "Format",
    "errorTryAgain": "Ein Fehler ist aufgetreten! Bitte versuchen Sie es später erneut…",
    "interestedInProducts": "Vielen Dank für Ihr Interesse an unseren Produkten.",
    "ok": "OK",
    "currentAccount": "Aktueller Zugang",
    "newInvalidDate": "Neues Ablaufdatum",
    "KontaktformularKenntnis": "Ich habe die __PRIVACY_POLICY__ zur Kenntnis genommen. Ich stimme zu, dass meine Angaben und Daten zur Beantwortung meiner Anfrage elektronisch erhoben und gespeichert werden.",
    "interval": "Intervall",
    "minute": "Minute",
    "minutes": "Minuten",
    "monday": "Montag",
    "tuesday": "Dienstag",
    "wednesday": "Mittwoch",
    "thursday": "Donnerstag",
    "friday": "Freitag",
    "saturday": "Samstag",
    "sunday": "Sonntag",
    "displayValue": "Anzeigewert",
    "conversions": "Umrechnungen",
    "add": "hinzufügen",
    "displayUnit": "Anzeigeeinheit",
    "none": "Keine",
    "close": "Schließen",
    "apply": "übernehmen",
    "note": "Hinweis",
    "deleteIrrevocably": "Die Daten werden unwiderruflich gelöscht!",
    "delete": "löschen",
    "errors": "Fehler",
    "noErrors": "Keine Fehler",
    "error": "Fehler",
    "deleted": "Gelöscht!",
    "entryDeleted": "Der Eintrag wurde gelöscht.",
    "save": "speichern",
    "edit": "bearbeiten",
    "status": "Status",
    "cancel": "Abbrechen",
    "weiter": "Weiter",
    "yesDelete": "Ja, löschen",
    "no": "Nein",
    "configurationDeleted": "Die Konfiguration wurde gelöscht.",
    "selectAll": "Alle auswählen",
    "unselectAll": "Alle abwählen",
    "download": "Download",
    "prefix": "Präfix",
    "subscription": "Zugang",
    "information": "Information",
    "passwordCurrent": "Aktuelles Passwort",
    "languageForEmail": "Sprache (E-Mails)",
    "defaultUnits": "Standardeinheiten",
    "dateFormat": "Datumsformat",
    "myPersonalSettings": "Meine persönlichen Daten",
    "changeYourPassword": "Passwort ändern",
    "login": "Login",
    "newPassword": "Neues Passwort",
    "passwordLength": "muss mindestens 6 Zeichen lang sein",
    "passwordConfirmNewPassword": "Neues Passwort bestätigen",
    "forgotYourPassword": "Passwort vergessen?",
    "passwordDifferent": "Die beiden Passwörter stimmen nicht überein!",
    "password": "Passwort",
    "nameResolRegler": "MTF-Regler",
    "pleaseChoose": "Bitte auswählen",
    "invalidCharacters": "Ungültige Zeichen",
    "chooseLanguage": "Sprache auswählen",
    "langGerman": "Deutsch",
    "langEnglish": "Englisch",
    "langFrench": "Französisch",
    "langItalian": "Italienisch",
    "langSpanish": "Spanisch",
    "langSuomi": "Finnisch",
    "showDiagram": "Diagramm anzeigen",
    "diagramTitle": "Diagramm-Titel",
    "publicLink": "Öffentlicher Link",
    "loadingData": "Lade Daten, bitte warten",
    "saving": "Speichere",
    "yourLiveData": "Ihre Live-Daten",
    "warningNoLivedata": "Keine Livedaten vorhanden!",
    "noResults": "Ihre Auswahl liefert keine Ergebisse!",
    "removeAll": "Alle entfernen",
    "undo": "Rückgängig",
    "originalNamesValues": "Originalnamen & -werte",
    "conversionAvailable": "Umrechnung vorhanden",
    "maxAllowedFilterValues": "Der Filter verfügt über mehr Werte als erlaubt! Ein Demo-Datalogger darf maximal 10 Filterwerte beinhalten. Beim Speichern werden nur die ersten 10 Filterwerte gespeichert.",
    "filterDeleted": "Der Filter wurde gelöscht.",
    "showCustomImages": "Eigene Bilder",
    "imageDeleted": "Das Bild wurde gelöscht.",
    "system": "System",
    "autoscaleDescription": "Live-System auf maximale Bildschirmgröße skalieren.",
    "lastSent": "Zuletzt gesendet",
    "on": "am",
    "language": "Sprache",
    "active": "aktiv",
    "inactive": "inaktiv",
    "daily": "Täglich",
    "weekly": "Wöchentlich",
    "monthly": "Monatlich",
    "settings": "Allgemeine Einstellungen",
    "online": "Online",
    "offline": "Offline",
    "confirmed": "bestätigt",
    "notConfirmed": "nicht bestätigt",
    "demo": "Demo",
    "accessDatalogger": "Der Zugriff für DVM Cloud Service ist im Web-Interface Ihres Kommunikationsmoduls zu finden!",
    "loginDatalogger": "Bitte loggen Sie sich im Web-Interface Ihres Kommunikationsmoduls ein und aktivieren Sie den Zugriff unter:",
    "settingsDatalogger": "Konfiguration / Fernzugriff / Zugriff über Internet",
    "timezone": "Zeitzone",
    "location": "Standort",
    "geodata": "Geo-Koordinaten",
    "search": "Suchen",
    "change": "Ändern",
    "advancedSettings": "Erweiterte Einstellungen",
    "visuaEnablingVbusnet": "DVM Cloud Service verbindet sich in regelmäßigen Abständen mit Ihrem Kommunikationsmodul, um aktuelle Daten zu laden. Hierdurch wird das Datenvolumen und die Übertragungsrate Ihres Internet-Zugangs benutzt. Falls Sie dies nicht möchten, können Sie den Datenverkehr hier deaktivieren. Beachten Sie, dass dann keine neuen Daten von DVM Cloud Service abgerufen werden und historische Daten auch nicht nachträglich von DVM Cloud Service synchronisiert werden.",
    "userComments": "Benutzer-Kommentare",
    "adminComments": "Admin-Kommentare",
    "accessToken": "Zugangscode / Token",
    "claimDevice": "Gerät hinzufügen",
    "yes": "Ja",
    "firmware": "Firmware",
    "serial": "Seriennummer",
    "enabled": "Erlaubt",
    "disabled": "Nicht erlaubt",
    "userComment": "Benutzer-Kommentar",
    "defaultSettings": "Grundeinstellungen",
    "controller": "Regler",
    "interface": "Schnittstelle",
    "technicalData": "Technische Daten",
    "privatePerson": "Privatperson",
    "topic": "Thema",
    "yourName": "Ihr Name",
    "addNoticeSing": "Bemerkung",
    "sendAdditionalInformation": "Ergänzende Daten für einen einfacheren Support senden",
    "Einwilligung": "Datenschutzrechtliche Einwilligung",
    "KontaktformularHinweis": "Sie können Ihre Einwilligung jederzeit für die Zukunft per E-Mail an datenschutz@dvm-cloud.net widerrufen.",
    "send": "senden",
    "feedbackText": "Allgemeines Feedback",
    "improvement": {
      "proposal": "Verbesserungsvorschlag"
    },
    "nameTechnicalSupport": "Technische Beratung",
    "question": "Frage",
    "hervorragend": "hervorragend",
    "gut": "gut",
    "neutral": "neutral",
    "ausreichend": "ausreichend",
    "unzureichend": "unzureichend",
    "kinderleicht": "kinderleicht",
    "intuitiv": "intuitiv",
    "kompliziert": "kompliziert",
    "nichtbedienbar": "nicht bedienbar",
    "unverzichtbar": "unverzichtbar",
    "sehrhilfreich": "sehr hilfreich",
    "teilweisenuetzlich": "teilweise nützlich",
    "unbrauchbar": "unbrauchbar",
    "sendResetPasswordInstructions": "Senden Sie mir Anweisungen, um mein Passwort zurückzusetzen",
    "nameTechnicalSupportTime": "Mo. - Fr. 08:00 - 16:30 Uhr ",
    "feedbackName": "Feedback",
    "feedback": "Feedback-Formular",
    "ImpressumAngaben": "Angaben gemäß § 5 TMG:",
    "Streitschlichtung": "Streitschlichtung",
    "StreitschlichtungText": "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
    "StreitschlichtungAllgemein": "Allgemeine Verbraucherschlichtungsstelle:",
    "nameDataloggerKomm": "Kommunikationsmodul KM2",
    "nameRouter": "Router",
    "Versionsvergleich": "BASIC versus PRO",
    "year": "Jahr",
    "passwordConfirmation": "Passwort-Bestätigung",
    "Pflichtfelder": "Die mit * gekennzeichneten Felder müssen ausgefüllt werden",
    "resendConfirmationInstuctions": "Bitte Bestätigungs-E-Mail erneut zusenden",
    "back": "zurück",
    "years": "Jahre",
    "basicLiveSystemText": "Mit dem Live-System-Editor können Sie ausgewählte Daten Ihrer Anlage ganz einfach in einem Systembild darstellen. Ziehen Sie die Daten per Drag&Drop an die gewünschte Position und platzieren Sie vorgefertigte Symbole wie z. B. Speicher und Ventile im Systembild. Die Daten werden alle 5 Minuten automatisch aktualisiert, ohne dass die Seite neu geladen werden muss.",
    "basicConnectionText": "DVM Cloud Service erlaubt den einfachen und sicheren Zugang zu Ihrem System, ganz ohne aufwendige Software-Installation oder Netzwerkkenntnisse.",
    "freeBasicFunctions": "Kostenlose Basis-Funktionen",
    "basicLiveDataText": "Die Live-Daten Ihres Systems können in einer übersichtlichen Tabelle angezeigt werden – auf diese Weise erhalten Sie alle aktuellen Messwerte auf einen Blick.",
    "basicDiagrammeText": "Gespeicherte Daten können in Form eines Diagramms angezeigt und individuell gestaltet werden.",
    "GeplanteDownloadsText": "Erhalten Sie regelmäßig und automatisch die gespeicherten Daten Ihrer Anlage per E-Mail. Sie können Zeiträume auswählen und beispielsweise weitere Empfänger festlegen.",
    "ReporteText": "Erhalten Sie individuell konfigurierbare Reporte über den Status der Solaranlage per E-Mail.",
    "GeraetTeilenText": "Teilen Sie Ihr Gerät mit anderen DVM-Cloud-Service-Usern  ̶  z. B. mit Ihrem Installateur oder Energieberater zu Informations- und Servicezwecken.",
    "SystemEditorText": "Nutzen Sie viele weitere Editierfunktionen, um Ihr Live-System individuell zu gestalten und  eigene Komponentenbilder sowie Systemgrafiken einzubinden.",
    "SicherungText": "DVM-Cloud-Service-Visualisierungseinstellungen können mit wenigen Klicks gesichert und wiederhergestellt werden.",
    "FehlerprotokollText": "Diese Funktion bietet eine Übersicht aufgetretener Fehler in Ihrem System und ermöglicht eine einfache und schnelle Fehlersuche.",
    "BenachrichtigungenText": "Mit dieser Funktion können Sie frei definierbare E-Mail-Benachrichtigungen an festgelegte Empfängerkreise, z. B. bei Fehlermeldungen, versenden.",
    "ParametrisierenText1": "Parametrisieren Sie Ihren Regler ganz einfach aus der Ferne über Ihren Internetbrowser. Speichern Sie Konfigurationen direkt in DVM Cloud Service und laden sie diese bei Bedarf auf Ihren Regler.",
    "basicText1": "Probieren Sie DVM Cloud Service aus – Die Basisversion ist kostenfrei und ein Demo-Datalogger steht direkt nach der Anmeldung zur Verfügung. Stellen Sie Daten in einem Live-System dar oder lassen Sie sich gespeicherte Daten in einem Diagramm anzeigen.",
    "basicConnection": "Sicherer Zugang zu Ihrem System",
    "basicLiveSystem": "Live-Systeme",
    "basicLiveData": "Live-Daten anzeigen",
    "basicDiagramme": "Diagramme",
    "proFunctions": "PRO-Funktionen im Überblick",
    "logout": "Abmelden",
    "Funktionsbeschreibung": "Funktionsbeschreibung",
    "kommunikationsmodulKM2": "Kommunikationsmodul KM2",
    "dataloggerDL2": "Datalogger DL2",
    "dataloggerDL3": "Datalogger DL3",
    "Informations": "Informationen",
    "tools": "Tools",
    "rechtliches": "Rechtliches",
    "products": "Produkte",
    "preferences": "Einstellungen",
    "menutype": "Quick-Navigation",
    "Visualisieren": "Visualisieren",
    "Ueberwachen": "Überwachen",
    "vbusnetRequirements": "Voraussetzungen für DVM Cloud Service",
    "vbusnetRequirementsText": "Für die Verwendung von DVM Cloud Service muss Ihr MTF-Regler mit VBus®-Datenschnittstelle lediglich über ein Kommunikationsmodul (KM2) mit dem Internet verbunden sein. Eine umständliche Software-Installation ist nicht notwendig.",
    "VisualisierenText1": "Mit den Visualisierungsmöglichkeiten von DVM Cloud Service haben Sie Ihre Anlagendaten immer im Blick.",
    "VisualisierenText2": "Visualisieren Sie Ihre Daten in einer übersichtlichen Systemgrafik oder erstellen Sie Diagramme, um Ihre Anlagendaten im Tages-, Wochen- oder Monatsverlauf darzustellen.",
    "UeberwachenText1": "Überwachen Sie Ihre Anlage ganz einfach über automatische Reporte und Benachrichtigungen.",
    "UeberwachenText2": "Lassen Sie sich in regelmäßigen Abständen über den Status Ihrer Solaranlage per E-Mail informieren. Somit sind Sie immer auf dem Laufenden und können direkt reagieren, falls ein Problem auftreten sollte. Erkennen Sie Probleme frühzeitig  ̶  Richten Sie Reporte ein und senden Sie diese zur Fehleranalyse an Ihren Installateur.",
    "ParametrisierenText2": "Folgende Solar- und Systemregler werden aktuell unterstützt:",
    "proAccountRequired": "Ein Fachpartner-Zugang ist erforderlich!",
    "inviteFriend": "Gerät teilen",
    "Parametrisieren": "Parametrisieren",
    "indexPortal": "Das Portal für Ihr Heizungs- und Solarsystem",
    "schnittstellenadapter": "Der VBus®/LAN-Schnittstellenadapter ist nicht kompatibel mit VBus.net!",
    "km2": {
      "title": "Preiswerte Lösung für den Fernzugriff auf den Regler",
      "text": "Das Kommunikationsmodul KM2 ist die ideale Schnittstelle zwischen einem Solar- oder Heizungsregler und dem Internet. Durch die einfache und sichere Verbindung zum DVM Cloud Service können Anlagendaten visualisiert und beispielsweise Reporte zum Anlagenstatus per E-Mail zur Verfügung gestellt werden."
    },
    "dl2": {
      "title": "Datalogger DL2 - Fernzugriff auf den Regler und integrierte Datenaufzeichnung",
      "text": "Der Datalogger DL2 ist die Schnittstelle zwischen einem RESOL-Regler und dem Internet und dient zusätzlich der Aufzeichnung von Anlagendaten. Der DL2 ermöglicht den Zugriff auf die Anlagendaten über www.VBus.net."
    },
    "dl3": {
      "title": "Datalogger DL3 – Datenaufzeichnung mit erweitertem Funktionsumfang",
      "text": "Der Datalogger DL3 dient der Datenaufzeichnung von bis zu 6 RESOL-Reglern und ermöglicht die Visualisierung über www.VBus.net und die Parametrisierung über RPT. Sein Vollgrafikdisplay gibt einen Überblick über die angeschlossenen Regler, alle wichtigen Einstellungen können direkt am DL3 vorgenommen werden. Die integrierten Sensor- und Impulseingänge können Temperaturen messen und aufzeichnen – auch ohne Regler. Der DL3 verfügt zudem über eine BACnet-Funktionalität für den BACnet-konformen Datenversand und ist somit ideal für die Einbindung in die Gebäudeleittechnik."
    },
    "profitPro": "Profitieren Sie von allen DVM-Cloud-Service-Funktionen und bestellen Sie sich Ihren Fachpartner-Zugang.",
    "Funktionsvergleich": "Funktionsvergleich",
    "danke": "MTF sagt Danke",
    "team": "Ihr MTF-Team",
    "errorRequired": "__Feld__ wird benötigt!",
    "errorInvalid": "__Feld__ ist fehlerhaft!",
    "errorNotEqual": "__Feld__ stimmt nicht überein!",
    "collapse": {
      "all": "alles zuklappen"
    },
    "expand": {
      "all": "alles aufklappen"
    },
    "help": "Hilfe",
    "loading": "lade",
    "data": "Daten",
    "notice": "Protokoll",
    "quickDiagram": "Direkt-Diagramm",
    "quickDownload": "direkter Download",
    "saved": "gespeichert",
    "unknow": "unbekannt",
    "warning": "Achtung",
    "upload": "Hochladen",
    "uploadCustomImage": "Eigenes Bild hochladen",
    "version": "Version",
    "device": "Gerät",
    "own": {
      "name": "Eigener Name"
    },
    "getFullVersion": "Vollversion",
    "limitations": "Einschränkungen",
    "filter": "erforderlich",
    "addNote": "Bemerkungen",
    "contactAdr": "Kontaktadresse",
    "loggedInAs": {
      "prefix": "Angemeldet als",
      "suffix": "Nicht Sie?"
    },
    "actions": "Aktionen",
    "tip": "Tipp",
    "info": "Info",
    "link": "Link",
    "register": "Registrieren",
    "or": "oder",
    "and": "und",
    "rememberMe": "Eingeloggt bleiben",
    "changeMyPassword": "Mein Passwort ändern",
    "wrongEmailOrPassword": "Ungültige E-Mail-Adresse oder ungültiges Passwort",
    "newOwnership": "Neues Gerät",
    "alert": "Achtung",
    "update": "Update",
    "comments": "Kommentare",
    "videos": "Videos",
    "downloads": "Downloads",
    "dokumente": "Dokumente",
    "datenblatt": "Datenblatt",
    "montageanleitung": "Montageanleitung",
    "filtern": "filtern",
    "type": "Art",
    "until": "bis",
    "datapoint": "Datenpunkt",
    "seconds": "Sekunden",
    "hours": "Stunden",
    "position": "Position",
    "move": "verschieben",
    "billingAdr": "Rechnungsadresse",
    "billingAdrAdd": "(falls abweichend von der Kontaktadresse)",
    "terminateFriend": "Zugang zum Gerät zurückziehen",
    "myFriends": "Meine geteilten Geräte",
    "custom": "benutzerdefiniert",
    "continuous": "kontinuierlich (24 Std./Tag)",
    "immediately": "sofort",
    "notificationPeriod": "Benachrichtigungszeitraum",
    "monitoringPeriod": "Beobachtungszeitraum",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "abbreviation": {
      "example": "z. B."
    },
    "price": "Preis",
    "functions": "Funktionen",
    "required": "erforderlich",
    "errorReport": "Fehlerbericht",
    "permanent": "unbefristet",
    "at": "um",
    "oClock": "Uhr",
    "unsubscribed": "abgemeldet",
    "every": "jeden",
    "pixel": "Pixel",
    "lagging": "Sehr geehrte Kunden,<br><br>der Zugriff auf DVM Cloud Service ist zurzeit verlangsamt.<br>Wir arbeiten an einer Lösung und bitten um Ihr Verständnis für die Unannehmlichkeiten.<br><br>Ihr DVM-Cloud-Service-Team",
    "offset": "Offset",
    "defaults": "Standardvorgaben",
    "deleteAll": "Alle löschen",
    "mustSelectOneOption": "Sie müssen mindestens eine Option auswählen!",
    "browserNotSupported": "Ihr Browser wird nicht unterstützt!<br/>Bitte aktualisieren Sie auf eine aktuelle Version.",
    "uploadErrorFile": "Datei kann nicht hochgeladen werden!",
    "errorSensor": "Sensorfehler",
    "new": "neu",
    "energyOffset": "Offset für Energiewerte",
    "weatherData": "Wetterdaten des Standortes",
    "gridLiveSystem": "Raster und Gitterfunktion zum besseren Positionieren",
    "dailyEnergyValues": "Tageszusammenfassung von Energiewerten",
    "overwriteWarning": "Die vorhandenen Daten werden überschrieben!",
    "maxFilesize": "max. Dateigröße",
    "factor": "Faktor",
    "removeConversions": "Umrechnungen entfernen",
    "chooseAltUnit": "Alternative Anzeige-Einheit auswählen…",
    "content": "Inhalte",
    "additionalContent": "Weitere Inhalte",
    "choseContent": "Inhalte auswählen",
    "publicLinkDiagrams": "Öffentliche Links zu Diagrammen",
    "publicLinkSchemes": "Öffentliche Links zu Live-Systemen",
    "deviceInfo": "Geräteinformationen",
    "noEnergyValuesInFilter": "In dem gewählten Filter sind keine Energiewerte vorhanden!",
    "warningSelectOnValue": "Sie müssen mindestens einen Filterwert auswählen!",
    "heatQuantityDay": "Wärmemenge Tag",
    "heatQuantityWeek": "Wärmemenge Woche",
    "heatQuantityMonth": "Wärmemenge Monat",
    "heatQuantityTotal": "Wärmemenge gesamt",
    "errorMessages": "Fehlermeldungen",
    "temperatureValuesIn": "Temperaturwerte in",
    "operator": "Betreiber",
    "systemType": "Anlagenart",
    "showLiveSystem": "Live-System anzeigen",
    "confirmationMail": "Bestätigungs-E-Mail",
    "noConfirmationMailreceived": "Keine Bestätigungs-E-Mail erhalten?",
    "backupHintReceivers": "Die Bestätigungs-E-Mail muss für alle Empfänger manuell versendet werden.",
    "notificationInterval": "Benachrichtigungsintervall",
    "oneEnergyInFilter": "Es muss mindestens ein Energiewert im Filter vorhanden sein!",
    "iUnderstand": "Ich habe verstanden.",
    "useCookies": "Diese Webseite verwendet Cookies.",
    "whatsNew": "Was ist neu?",
    "nameTelefon": "Telefon: +49 (0) 23 24/96 48-0",
    "nameFax": "Fax: +49 (0) 23 24/96 48-755",
    "nameEmail": "info@dvm-cloud.net",
    "slide1": "Individuelle Diagramme",
    "slide2": "Live-Systeme",
    "slide3": "Automatische Reporte per E-Mail ",
    "slide4": "So funktioniert‘s",
    "nextSteps": "Nächste Schritte",
    "clickHereForMoreInformation": "Klicken Sie hier für mehr Infos…",
    "clickHere": "Klicken Sie hier…",
    "learnMore": "Erfahren Sie mehr…",
    "firstSteps": "Erste Schritte in DVM Cloud Service",
    "deviceName": "Gerätename",
    "forWeatherData": "Für Wetterdaten",
    "dataloggerOrCommunicationModule": "Kommunikationsmodul KM2",
    "downloadComplete": "Download vollständig",
    "automaticallyConfirmed": "Ihre E-Mail-Adresse (unter Mein Profil) ist automatisch aktiv. Neue E-Mail-Empfänger müssen zuvor den Empfang  bestätigen.",
    "downloaded": "heruntergeladen",
    "templates": "Vorlagen",
    "template": "Vorlage",
    "addTemplate": "Vorlage hinzufügen",
    "noTemplateAvailable": "Für dieses System ist keine Vorlage verfügbar.",
    "templateAdded": "Die Vorlage wurde erfolgreich hinzugefügt.",
    "channel": "Kanal",
    "vbusConnection": "VBus-Anschluss",
    "optional": "optional",
    "unknownError": "Ein unbekannter Fehler ist aufgetreten",
    "menuLanguage": "Menüsprache",
    "reloadPageNow": "Diese Seite jetzt neu laden",
    "noDevicesFound": "Es wurden keine Geräte am VBus gefunden.",
    "Haftungsausschluss": "Haftungsausschluss",
    "PrivacyPolicy": "Datenschutzerklärung",
    "TermsOfUse": "Nutzungsbedingungen",
    "Verantwortlich55RStV": "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV",
    "UmsatzsteuerIdUg": "Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz",
    "VertGeschFuehrer": "Vertretungsberechtigter Geschäftsführer",
    "DsgvoStart": "Am 25. Mai 2018 tritt die neue Datenschutzgrundverordnung (DSGVO) in Kraft.",
    "DsgvoStarted": "Am 25. Mai 2018 trat die neue Datenschutzgrundverordnung (DSGVO) in Kraft.",
    "DsgvoText": "Die DSGVO beinhaltet umfangreiche Vorschriften und Informationspflichten zur Verarbeitung und zum Schutz von personenbezogenen Daten. ",
    "acceptEulaMessage": "Nutzungsbedingungen und Datenschutzerklärung akzeptieren",
    "weather": "Wetter",
    "other": "Sonstige",
    "fullscreen": "Vollbild",
    "createFilterFirst": "Sie müssen zuerst einen Filter erstellen…",
    "deviceFilter": "Gerätefilter",
    "filterLisyByOnlineStatus": "Liste nach Online-Status filtern",
    "filterLisyByDeviceType": "Liste nach Gerätetyp filtern",
    "sorting": "Sortierung",
    "noDataLoaded": "Es konnten keine Daten geladen werden, bitte laden Sie die Seite erneut!",
    "showLegend": "Legende einblenden",
    "symbol": "Symbol",
    "chooseHeatQuantities": "Sie können bis zu 3 Wärmemengen auswählen",
    "twoFactorAuthentication": "Zwei-Faktor-Authentifizierung (2FA)",
    "faq": "Häufig gestellte Fragen",
    "copyToClipboard": "In die Zwischenablage kopieren",
    "worst": "sehr schlecht",
    "bad": "schlecht",
    "weak": "schwach",
    "good": "gut",
    "strong": "stark",
    "automaticUpdate": "Automatische Aktualisierung in __SECONDS__ Sekunden",
    "axisSettings": "Achseneinstellungen",
    "engaged": "Ein",
    "off": "Aus",
    "setup2FA": "Zwei-Faktor-Authentifizierung einrichten",
    "remove2FA": "Zwei-Faktor-Authentifizierung entfernen",
    "setupShort2FA": "2FA einrichten",
    "removeShort2FA": "2FA entfernen",
    "recovery2FA": "Wiederherstellungscodes",
    "qr2FA": "QR-Code",
    "authenticator2FA": "Authenticator-Code",
    "code12FA": "Wiederherstellungcodes können für den Zugang zu Ihrem DVM-Cloud-Service-Konto benutzt werden, falls Sie keinen Zugriff auf Ihre Zwei-Faktor-Authentifizierungs-App haben sollten.",
    "code22FA": "Behandeln Sie die Wiederherstellungscodes mit derselben Aufmerksamkeit wie Sie dies bei Ihrem Passwort tun würden. Wir empfehlen die Speicherung in einem Passwort-Manager.",
    "code32FA": "Die Wiederherstellungscodes können nur für das einmalige Einloggen benutzt werden. Nach einem erfolgreichen Login verlieren diese ihre Gültigkeit.",
    "code42FA": "Speichern Sie Ihre Wiederherstellungcodes oder drucken Sie diese aus, bevor Sie mit der Einrichtung der Zwei-Faktor-Authentifizierung fortfahren.",
    "code52FA": "Sollten Sie die Wiederherstellungscodes verlieren und keinen Zugang mehr zu Ihrer Zwei-Faktor-Authentifizierungs-App haben, ist kein Login mehr möglich!",
    "print": "Drucken",
    "code62FA": "Bitte scannen Sie den Barcode mit Ihrer Authenticator-App. Danach auf WEITER klicken.",
    "code72FA": "Bitte geben Sie den Code Ihrer Authenticator-App ein und klicken auf FERTIGSTELLEN.",
    "finish": "Fertigstellen",
    "invalid2FA": "Der eingegebene Authenticator-Code ist ungültig. Bitte versuchen Sie es noch einmal.",
    "success2FA": "Ihre Zwei-Faktor-Authentifizierung wurde erfolgreich eingerichtet!",
    "examples": "Hilfe",
    "notPossibleMobile": "Diese Funktion steht auf einem mobilen Gerät nicht zur Verfügung!",
    "dateAndTime": "Datum und Uhrzeit",
    "deviceOverview": "Geräteübersicht",
    "deviceMap": "Gerätestandort-Karte",
    "minimumSize": "Mindestgröße",
    "maximumSize": "maximale Größe",
    "activation": "Aktivierung",
    "switchToPro": "Jetzt zum Fachpartner-Zugang wechseln",
    "documentNotFound": "Das angegebene Dokument konnte auf unserem Server leider nicht gefunden werden.",
    "startPage": "Startseite",
    "clear": "Zurücksetzen",
    "helpAndSupport": "Hilfe & Support",
    "fileUpload": "Datei hochladen",
    "fileUploadText": "Die Datei __FILENAME__ wird auf den Server geladen. Bitte warten…",
    "unsupportedFileType": "Der Dateityp wird nicht unterstützt!",
    "invalidCharactersFilename": "Der Dateiname darf keine Sonderzeichen oder Umlaute enthalten!",
    "invalidFileSize": "Die Datei ist zu groß! (max. 15 MB)",
    "errorLoadData": "Fehler beim Laden der Daten!",
    "unknownExceptionError": "Unbekannter Ausnahmefehler",
    "demoDevice": "Demogerät",
    "friendDevice": "Freundschaftsgerät",
    "temperatureSensor": "Temperatursensor",
    "switch": "Schalter",
    "alreadyClaimedDemo": "Sie haben bereits einen Demo-Datalogger zu Ihrem Benutzerkonto hinzugefügt.",
    "function": "Funktion",
    "convertValue": "Wert umrechnen",
    "tokenNotWorking": "Schade, das hat nicht geklappt. Versuchen Sie doch einen anderen Token/Coupon.",
    "divisionByZero": "Division durch 0!",
    "passwordStrength": "Passwortstärke",
    "chartType": "Diagrammtyp",
    "autoscale": "Automatisch skalieren",
    "time": "Uhrzeit",
    "factoryDefault": "Werkseinstellung",
    "initialize": "Initialisierung",
    "addDataloggerCommunicationModule": "Klicken Sie hier, um Ihrem Benutzerkonto ein Kommunikationsmodul hinzuzufügen.",
    "twoFactorRemovedSuccessful": "Ihre Zwei-Faktor-Authentifizierung wurde erfolgreich entfernt!",
    "hideLegend": "Legende ausblenden",
    "warningUnknownLivedata": "Fehler beim Lesen der Live-Daten!",
    "default": "Standard",
    "passwordIsEmail": "Das Passwort darf nicht identisch mit der E-Mail-Adresse sein!",
    "unknownDevice": "Unbekanntes Gerät",
    "noSettingsAvailable": "Keine Einstellungen verfügbar!",
    "errorLoadImage": "Bild konnte nicht geladen werden!",
    "errorLoadWeather": "Wetterdaten konnten nicht geladen werden!",
    "errorLoadLiveSystem": "Live-System konnte nicht geladen werden!",
    "weekday": "Wochentag",
    "createdAt": "erstellt am",
    "tooltip": "Tooltip",
    "subtitle": "Untertitel",
    "lastUpdated": "letzte Änderung",
    "preview": "Vorschau",
    "extendSubscription": "Zugang verlängern",
    "loginToExtendSubscription": "Um Ihren DVM-Cloud-Service-Zugang zu verlängern, müssen Sie sich zunächst einloggen.",
    "orderedSubscription": "Bestellter Zugang",
    "yourAccount": "Ihr DVM-Cloud-Service-Zugang ",
    "unlimited": "unbegrenzt",
    "emailAlreadyExists": "E-Mail-Adresse bereits vorhanden",
    "selectDecices": "Geräte auswählen",
    "description": "Beschreibung",
    "decimals": "Nachkommastellen",
    "needInvoice": "Sie benötigen eine Rechnung?",
    "proAccount": "DVM-Cloud-Service-Fachpartner-Zugang",
    "businessAccount": "VBus.net Business-Zugang",
    "convertFilterValue": "Mit Filterwert rechnen",
    "doNotShowAgain": "Diese Meldung nicht wieder anzeigen.",
    "toggle": "Alle anzeigen / ausblenden",
    "numberFormat": "Zahlenformat",
    "checkVBusConnection": "Bitte prüfen Sie die VBus-Leitung zwischen Regler und {1}!",
    "liveDataNotUpToDate": "Diese Live-Daten sind nicht aktuell! Letzte Aktualisierung: {1}",
    "news": "Neuigkeiten",
    "hide": "ausblenden",
    "archive": "Archivieren",
    "noNewMessages": "Keine neuen Mitteilungen",
    "messages": "Mitteilungen",
    "viewArchivedMessages": "Archivierte Mitteilungen anzeigen",
    "readNow": "jetzt lesen",
    "customerOpinions": "Kundenmeinungen",
    "globalErrorTitle": "Technische Störung!",
    "globalErrorMessage": "Leider gibt es aktuell technische Probleme. Wir arbeiten bereits an einer Lösung.",
    "globalSuccessTitle": "Störung behoben",
    "globalSuccessMessage": "DVM Cloud Service ist nach technischen Problemen wieder in vollem Umfang verfügbar. Sollte Ihr Kommunikationsmodul noch offline sein, folgen Sie bitte dieser Anleitung in den FAQs.",
    "endOfQuarter": "Ende des Quartals",
    "lastQuarter": "Letztes Quartal",
    "licenseText": "Lizenztext",
    "invalidToken": "Ungültiger Token",
    "selectDay": "Tag auswählen",
    "selectCalendarWeek": "Kalenderwoche auswählen",
    "selectMonth": "Monat auswählen",
    "selectYear": "Jahr auswählen",
    "calendarWeek": "Kalenderwoche",
    "calendarWeekShort": "KW",
    "selectQuarter": "Quartal auswählen",
    "dataloggerDL2Plus": "Datalogger DL2 Plus",
    "geodataFormatDecimal": "Dezimalformat z.B. 51.3970, 7.2169",
    "geodataFormatSexagesimal": "Sexagesimalformat z.B. 51° 23' 49.5361\", 7° 13' 00.8945\"",
    "noData": "Keine Daten!",
    "automaticConversion": "Automatische Konvertierung."
  },
  "vbusnet": {
    "email": {
      "confirmText": "Vielen Dank für die Registrierung bei DVM Cloud Service. Bitte bestätigen Sie Ihr Benutzerkonto mit dem unten stehenden Link:",
      "confirmMyAccount": "Mein Benutzerkonto bestätigen",
      "requestNewPassword": "Jemand hat einen Link angefordert, um Ihr Passwort zu ändern. Sie können dies über den unten stehenden Link tun.",
      "changeMyPassword": "Mein Passwort ändern",
      "didNotRequestThisText": "Wenn Sie diese E-Mail nicht angefordert haben, ignorieren Sie sie bitte.",
      "passwordWontChangeText": "Ihr Passwort wird nicht geändert, es sei denn, Sie klicken den obigen Link an und erstellen ein neues Passwort."
    },
    "demo_ownership_description": "Dieser Demo-Datalogger stellt Daten eines Solarthermie- und Heizsystems im Westen Deutschlands zur Verfügung. Die interessantesten VBus-Felder sind:",
    "demo_datalogger": "Der Demo-Datalogger verfügt lediglich über eingeschränkte Bearbeitungsmöglichkeiten."
  },
  "visualization": {
    "scheduledDownloadBodyAttachment": "Im Anhang dieser E-Mail finden Sie Ihren geplanten Download.",
    "scheduledDownloadBodyNoAttachment": "Diese E-Mail enthält keinen geplanten Download. Vermutlich liegen für den ausgewählten Zeitraum keine Daten vor.",
    "scheduledDownloadSubjectDaily": "Ihr täglicher geplanter Download",
    "scheduledDownloadSubjectWeekly": "Ihr wöchentlicher geplanter Download",
    "scheduledDownloadSubjectMonthly": "Ihr monatlicher geplanter Download",
    "report": "Report",
    "reportConfirmSubject": "Bitte bestätigen Sie den neuen Report.",
    "scheduledDownload": "Geplanter Download",
    "scheduledDonwloadConfirmSubject": "Bitte bestätigen Sie den neuen geplanten Download.",
    "scheduledDownloadConfirmMessage": "Wenn Sie in Zukunft über den folgenden geplanten Download informiert werden wollen, klicken Sie auf den unten stehenden Link:",
    "scheduledDownloadUnsubscribe": "Keine weiteren E-Mails zu diesem geplanten Download erhalten.",
    "reportConfirmMessage": "Wenn Sie in Zukunft über den folgenden Report informiert werden wollen, klicken Sie auf den unten stehenden Link:",
    "reportUnsubscribe": "Keine weiteren E-Mails zu diesem Report erhalten.",
    "nameImage": "Bild",
    "nameFilter": "Filter",
    "nameDiagram": "Diagramm",
    "nameScheme": "System",
    "maxCustomerImages": "Maximal 3 eigene Bilder können hochgeladen werden",
    "accepting": {
      "text": {
        "eula": "Endbenutzer-Lizenz- und Datenschutzvereinbarung akzeptieren",
        "accept": "Jetzt akzeptieren"
      }
    },
    "downloadFormatTextTabWin": "Text (Tabulator, Windows)",
    "downloadFormatTextSemWin": "Text (Semikolon, Windows)",
    "downloadFormatTextTabLin": "Text (Tabulator, Linux)",
    "downloadFormatTextSemLin": "Text (Semikolon, Linux)",
    "downloadFormatVbus": "VBus-Protokoll-Daten",
    "nameDownload": "Download",
    "nameReport": "Report",
    "addScheduledDownload": "Neuen geplanten Download hinzufügen",
    "enabling": {
      "text": {
        "vbusnet": "Visualisierung mit DVM Cloud Service erlauben",
        "eula": "Durch die Aktivierung dieser Option stimmen Sie zu, dass Ihre Daten durch unseren Service gemäß <a href='/eula'>Endbenutzer-Lizenzvereinbarung</a> gespeichert werden!"
      }
    },
    "allowParameterizationTextPlain": "Parametrisierung über die Via-Adresse und das Parameterization Tool (RPT) erlauben",
    "settings": "Visualisierungseinstellungen",
    "allowParameterizationText": "Parametrisierung über die Via-Adresse und das <a href='http://www.resol.de/index/software/sprache/en' target='_blank'>RESOL Parameterization Tool (RPT)</a> erlauben",
    "scheduledDownloads": "Geplante Downloads",
    "myImage": "Mein Bild",
    "myFilter": "Mein Filter",
    "myScheme": "Mein System",
    "myDiagram": "Mein Diagramm",
    "myDownload": "Mein Download",
    "myScheduledDownload": "Mein geplanter Download",
    "myReport": "Mein Report",
    "myWeather": "Mein Wetter",
    "downloadButton": "herunterladen",
    "saveButton": "speichern",
    "showButton": "anzeigen",
    "reportsSelectPeriod": "Bitte einen Zeitraum auswählen",
    "extendedReportsInfo": "Erhalten Sie regelmäßig Informationen über den Status Ihres Systems per E-Mail. Lassen Sie sich z. B. 1 x pro Woche über den Ertrag (als Diagramm), Fehlermeldungen usw. informieren.",
    "extendedReportsWeekInfo": "Bei der Auswahl \"Wöchentlich\" erhalten Sie die Daten der <strong>letzten sieben Tage</strong> ab dem ausgewählten Tag.",
    "extendedReportsMonthInfo": "Bei der Auswahl \"Monatlich\" erhalten Sie die Daten des <strong>letzten vollständigen Kalendermonats</strong> jeweils am ersten Tag des Monats zur gewünschten Uhrzeit.",
    "extendedReportsYearChart": "Jahresübersicht",
    "extendedReportsWithYearChart": "Mit Jahresübersicht",
    "extendedReportsFilterInfo": "Für einen ausgewählten Datenpunkt wird ein Diagramm erzeugt. Sofern gewünscht, wird ebenfalls ein Jahresdiagramm für diesen Datenpunkt erzeugt.",
    "sendReportAfterSave": "Nach dem Speichern einen Report versenden.",
    "sendScheduledDownloadAfterSave": "Nach dem Speichern einen geplanten Download versenden.",
    "sendScheduledDownloadNow": "Geplanten Download jetzt senden",
    "sendReportNow": "Report jetzt senden",
    "sendScheduledDownloadNowDialog": "Möchten Sie Ihren geplanten Download jetzt auf aktiv setzen und danach per E-Mail erhalten?",
    "sendReportNowDialog": "Möchten Sie Ihren Report jetzt auf aktiv setzen und danach per E-Mail erhalten?",
    "scheduledDownloadSubjectQuarter": "Ihr Quartalsreport"
  },
  "monitoring": {
    "weeklyReport": "Ihr wöchentlicher Report",
    "monthlyReport": "Ihr monatlicher Report",
    "notificationConnectMail": "Sie erhalten eine E-Mail, sobald die Verbindung wiederhergestellt ist.",
    "notificationDisconnected": "Die Verbindung zum Gerät ist unterbrochen!",
    "notificationStillDisconnected": "Die Verbindung zum Gerät ist weiterhin unterbrochen!",
    "notificationDisconnectedNoMail": "Sie erhalten keine weitere E-Mail zum Verbindungsabbruch.",
    "notificationConnected": "Die Verbindung zum Gerät ist wiederhergestellt.",
    "errormaskTrue": "Fehlermaske meldet Fehler",
    "errormaskFalse": "Fehlermaske meldet keine Fehler",
    "mailer": {
      "warning": {
        "subject": "Warnung"
      },
      "error": {
        "subject": "Fehler"
      },
      "notificationConfirm": {
        "subject": "Bitte bestätigen Sie die neue Benachrichtigung."
      },
      "connection": {
        "subject": "Verbindungsstatus"
      },
      "notification": {
        "message": "Wenn Sie in Zukunft über die folgende Benachrichtigung informiert werden wollen, klicken sie auf den untenstehenden Link:",
        "urlText": "Diese E-Mail-Adresse bestätigen.",
        "unsubscribe": "Keine weiteren E-Mails zu dieser Benachrichtigung erhalten."
      },
      "userText": "Benutzertext"
    },
    "thresholdTrue": "Grenzwert erreicht",
    "repealed": "aufgehoben",
    "notification": "Benachrichtigung",
    "statusHasChanged": "Der Status einer Ihrer Bedingungen aus der folgenden Benachrichtigung hat sich geändert.",
    "allConditionsAreFulfilled": "Alle Bedingungen aus der folgenden Benachrichtigung sind erfüllt.",
    "notificationConfirmed": "Ihre E-Mail-Adresse wurde erfolgreich bestätigt.",
    "notificationAlreadyConfirmed": "Ihre E-Mail-Adresse wurde bereits bestätigt.",
    "notificationInvalidToken": "Ungültiger Bestätigungscode!",
    "timePeriod": "Zeitraum",
    "receiver": "Empfänger",
    "addNewReceiver": "Neuen Empfänger hinzufügen",
    "errorOccurred": "Fehler aufgetreten",
    "errorEliminated": "Fehler beseitigt",
    "add": {
      "notification": "Neue Benachrichtigung hinzufügen",
      "action": "Neue Aktion hinzufügen"
    },
    "notificationConnectionMessage": "Die Verbindung zu Ihrem Gerät wird automatisch überwacht!<br>Sollte das Gerät länger als {1} Minuten nicht mit DVM Cloud Service verbunden sein, erhalten Sie eine E-Mail über den Verbindungsabbruch. Sie werden zweimal nach jeweils 24 Stunden über den Verbindungsabbruch informiert und Sie erhalten eine E-Mail, sobald die Verbindung wiederhergestellt ist.",
    "errorLog": "Fehlerprotokoll",
    "myNotification": "Meine Benachrichtigung",
    "conditions": "Bedingungen",
    "addNewCondition": "Neue Bedingung hinzufügen",
    "selectDatapoint": "Datenpunkt auswählen",
    "actions": "Aktionen",
    "allConditionsFulfilled": "alle Bedingungen müssen erfüllt sein",
    "oneConditionFulfilled": "mindestens eine Bedingung muss erfüllt sein",
    "message": "Mitteilung",
    "hintNotification": "Sie müssen mindestens eine Bedingung und eine Aktion hinzufügen, um eine Benachrichtigung zu speichern!",
    "edit": {
      "notification": "Benachrichtigung bearbeiten"
    },
    "delete": {
      "notification": "Benachrichtigung löschen?"
    },
    "criterion": "Kriterium",
    "delay": "Verzögerung",
    "trippingTime": "Auslösezeit",
    "receivers": "Empfänger",
    "numberOfConditions": "Anzahl Bedingungen",
    "allConditionsFulfilled ": "alle Bedingungen müssen erfüllt sein",
    "oneConditionFulfilled ": "mindestens eine Bedingung muss erfüllt sein",
    "addNewTemperatureNotification": "Neue Temperaturbenachrichtigung hinzufügen",
    "addNewErrorNotification": "Neue Fehlerbenachrichtigung hinzufügen",
    "overriding": "Überschreitung",
    "lower deviation": "Unterschreitung",
    "warning": {
      "value": "Warn-Wert"
    },
    "error": {
      "value": "Fehler-Wert"
    },
    "numberOfActions": "Anzahl Aktionen",
    "action": "Aktion",
    "relatedActions": "Verbundene Aktionen",
    "threshold": "Grenzwert",
    "warningThreshold": "Grenzwert Warnung",
    "errorThreshold": "Grenzwert Fehler",
    "absoluteValue": "Absolutwert",
    "difference": "Differenz",
    "minimum": "Minimum",
    "maximum": "Maximum",
    "greaterOrEqual": "größer gleich",
    "lessOrEqual": "kleiner gleich",
    "greaterThan": "größer",
    "lessThan": "kleiner",
    "unequal": "ungleich",
    "dailyReport": "Ihr täglicher Report",
    "reportMessageBodyAttachment": "Im Anhang dieser E-Mail finden Sie Ihren Report.",
    "reportMessageBodyNoAttachment": "Diese E-Mail enthält keinen Report. Vermutlich liegen für den ausgewählten Zeitraum keine Daten vor.",
    "currentValue": "Aktueller Wert",
    "condition": "Bedingung",
    "disconnectionNotification": "Benachrichtigung über Verbindungsabbruch",
    "noDisconnectionNotification": "Die Verbindung zu Ihrem Gerät wird nicht überwacht!"
  },
  "account": {
    "emailNewConfirmation": "Neue E-Mail-Adresse bestätigen",
    "changeEmailBodyText": "Sie haben Ihre E-Mail-Adresse geändert. Um die neue E-Mail-Adresse zu bestätigen, klicken Sie auf den unten stehenden Link:",
    "activation": {
      "error": "Es ist ein Fehler aufgetreten. Bitte wiederholen Sie die Aktion."
    },
    "changeEmailSuccessful": "Die neue E-Mail-Adresse wurde erfolgreich bestätigt.",
    "emailNew": "Neue E-Mail-Adresse ",
    "changeEmail": "E-Mail-Adresse ändern",
    "areYouSure": "Sind Sie sicher?",
    "username": "Benutzername",
    "cancel": "Mein Benutzerkonto löschen",
    "unhappy": "Unzufrieden?",
    "deleteMyAccount": "Mein Benutzerkonto löschen",
    "changePassword": "Passwort ändern",
    "create": {
      "user": "Neues Benutzerkonto anlegen"
    },
    "edit": {
      "user": "Benutzerkonto bearbeiten"
    },
    "password": {
      "CurrentPasswordMessage": "Um die Änderungen zu bestätigen, benötigen wir Ihr aktuelles Passwort"
    },
    "understoodEulMessage": "Ich habe die <a href='/eula'>Endbenutzer-Lizenzvereinbarung</a> gelesen und verstanden.",
    "emailConfimationText": "Eine Nachricht mit einem Bestätigungs-Link ist an Ihre E-Mail-Adresse versendet worden. Um Ihr Benutzerkonto zu aktivieren, klicken Sie auf den Bestätigungs-Link.",
    "passwordNew": "Neues Passwort",
    "passwordOld": "Altes Passwort",
    "passwordNewConfirmation": "Neues Passwort bestätigen",
    "userData": "Benutzerdaten",
    "invalid_token": "Sie haben Ihr DVM-Cloud-Service-Konto erfolgreich aktiviert. Sie können sich nun mit Ihren Zugangsdaten einloggen.",
    "emailOrUsername": "E-Mail oder Benutzername",
    "changeEmailInServices": "Wenn Sie die E-Mail-Adresse ändern, wird diese ebenfalls automatisch in den folgenden Diensten geändert:",
    "changeEmailConfirmation": "Es wurde eine Bestätigungs-E-Mail an __EMAIL__ gesendet. Bitte klicken Sie auf den Link in der E-Mail, um die neue Adresse zu bestätigen.",
    "acceptEulaMessage": "Nutzungsbedingungen und Datenschutzerklärung akzeptieren",
    "AcceptEula": "Um DVM Cloud Service weiter nutzen zu können, müssen Sie unsere Nutzungsbedingungen und Datenschutzerklärung akzeptieren. "
  },
  "order": {
    "yourOrderSubject": "Ihre Bestellung bei DVM Cloud Service",
    "salesTaxIdentificationNumber": "USt.-IDNr.",
    "positions": "Positionen",
    "oneYearPro": "1 x DVM-Cloud-Service-Fachpartner-Zugang (1 Jahr) 39,00 €",
    "bankDetails": "Bankverbindung",
    "paymentDetails": "Aufgrund der gewünschten Zahlungsart per Überweisung werden wir Ihnen umgehend unsere Rechnung per E-Mail zukommen lassen. Bitte überweisen Sie an die dort angegebene Bankverbindung und geben unbedingt die Rechnungsnummer und Ihre DVM-Cloud-Service-E-Mail-Adresse an, damit wir die Zahlung zuordnen können.",
    "activatedAfterPayment": "Nach Erhalt der Zahlung wird Ihr DVM-Cloud-Service-Fachpartner-Zugang freigeschaltet.",
    "upToThreeDays": "Dieser Vorgang kann bis zu 3 Tage dauern.",
    "reference": "Verwendungszweck",
    "paymentMethod": "Zahlungsart",
    "order": "Bestellung",
    "confirmation": "Sie erhalten in wenigen Minuten eine Bestellbestätigung per E-Mail mit den Zahlungshinweisen. Nach Erhalt der Zahlung wird Ihr DVM-Cloud-Service-Fachpartner-Zugang freigeschaltet.",
    "paymentPaypal": "Zahlung per Paypal",
    "paymentBankTransfer": "Zahlung per Überweisung",
    "paymentPerMail": "Rechnung per E-Mail an",
    "now": "Jetzt bestellen",
    "linkAgb": "Es gelten unsere Allgemeinen Geschäftsbedingungen AGB",
    "mustConfirm": "Sie müssen zuerst zustimmen",
    "VbusVisulizationVor2013": "VBus.net-Zugang für DL2 vor Baujahr 2013 bestellen",
    "withCost": "Kostenpflichtig bestellen",
    "VbusVisulization": "Ja, ich möchte den DVM-Cloud-Service-Visualisierungs-Zugang bestellen.",
    "description": "Die einmaligen Kosten für den DVM-Cloud-Service-Visualisierungs-Zugang betragen <b>20,- EUR<br/>(inklusive MwSt)</b>. Kurz nach Ihrer Bestellung bekommen Sie eine Auftragsbestätigung<br/>per E-Mail zugesandt.",
    "umstid": "USt-IdNr.",
    "billingAdressAdd": "Rechnungsadresse<br/>(falls abweichend von der Kontaktadresse)",
    "dl2": {
      "bevor2012": "VBus.net-Zugang für DL2 vor Baujahr 2013",
      "thanks": "Vielen Dank, dass Sie sich für DVM Cloud Service entschieden haben. Ihr Zugang ist ab sofort freigeschaltet. Wir wünschen Ihnen viel Spaß mit den erweiterten Funktionen."
    },
    "vatIncluded": "inkl. MwSt.",
    "salutaion": "Sehr geehrte/r ",
    "thanksForOrder": "vielen Dank für Ihren Auftrag vom",
    "orderDetails": "Einzelheiten zum Auftrag:",
    "emailReference": "Bitte geben Sie bei Ihrer Überweisung als Verwendungszweck unbedingt Ihre DVM-Cloud-Service-E-Mail-Adresse an, damit wir Ihre Zahlung zuordnen können.",
    "sendOrder": "Bestellung absenden",
    "accountUpdated": "Ihr DVM-Cloud-Service-Zugang wurde aktualisiert.",
    "currentSubscription": "Bisheriger Zugang:",
    "newSubscription": "Neuer Zugang:",
    "validUntil": "gültig bis"
  },
  "professional": {
    "willExpire": "Ihr DVM-Cloud-Service-Fachpartner-Zugang läuft in {1} Tagen ab.",
    "order": {
      "euvat": {
        "explanation": "Hiermit bestätige ich, dass mein Hauptwohnsitz im oben genannten Land liegt. Dies dient als Grundlage zur Berechnung der Mehrwertsteuer (nur für Käufer innerhalb der EU)."
      },
      "information": {
        "required": "Informationen benötigt"
      },
      "require": {
        "text": "Der Verkäufer dieses Artikels benötigt die folgenden Informationen:"
      },
      "received": "Wir haben Ihre PayPal-Zahlung erhalten.",
      "thanks": "Vielen Dank, dass Sie sich für den Fachpartner-Zugang entschieden haben. Ihr Fachpartner-Zugang ist ab sofort freigeschaltet. Wir wünschen Ihnen viel Spaß mit den erweiterten Funktionen.",
      "redirect": {
        "wait": "Ihre Bestellung wird nun an PayPal gesendet. ",
        "wait2": "Dies kann einige Sekunden dauern."
      }
    },
    "own": {
      "scheme": {
        "images": "Eigene Systemgrafiken"
      }
    },
    "data": {
      "live": {
        "time": "Datenspeicherung"
      }
    },
    "function": {
      "overview": "Funktionsübersicht über die DVM-Cloud-Service-Zugänge"
    },
    "time": {
      "live": {
        "data": "Datenaktualisierung"
      }
    },
    "enhanced": {
      "scheme": {
        "editor": "Erweiterter System-Editor"
      }
    },
    "dl2": {
      "inclusive": "Zugang für DL2 vor 2013 inkl."
    },
    "error": {
      "protocol": "Fehlerprotokoll"
    },
    "monitoring": "Benachrichtigungen",
    "friendship": {
      "function": "Gerät teilen"
    },
    "subscription": {
      "name": {
        "basic": "Basic",
        "professional": "PRO"
      }
    },
    "subscriptionRequired": "Für diese Aktion benötigen Sie einen DVM-Cloud-Service-Fachpartner-Zugang.",
    "expired": "Abgelaufen",
    "extendOneYear": "Um 1 Jahr verlängern (kostenpflichtig)"
  },
  "extend": {
    "professional": {
      "account": "Fachpartner-Zugang jetzt verlängern"
    }
  },
  "address": {
    "herr": "Herr",
    "frau": "Frau",
    "billingAddress": "Rechnungsadresse",
    "firma": "Firma",
    "anrede": "Anrede",
    "vorname": "Vorname",
    "nachname": "Nachname",
    "strasse1": "Straße 1",
    "strasse2": "Straße 2",
    "postleitzahl": "Postleitzahl",
    "ort": "Ort",
    "plz": "PLZ",
    "land": "Land",
    "businessCustomer": "Firmenkunde",
    "privateCustomer": "Privatkunde",
    "email": "E-Mail",
    "telefon": "Telefon",
    "fax": "Fax",
    "internet": "Internet",
    "strasse": "Straße",
    "bundesland": "Bundesland",
    "kundennummer": "Kundennummer",
    "webseite": "Webseite",
    "name": {
      "first": "Vorname",
      "last": "Nachname"
    },
    "address": "Adresse",
    "kunde": "Kunde"
  },
  "backbone": {
    "validation": {
      "required": "wird benötigt",
      "email": "muss eine gültige E-Mail-Adresse sein",
      "acceptance": "muss bestätigt werden",
      "min": "muss größer oder gleich {1} sein",
      "max": "muss kleiner oder gleich {1} sein",
      "range": "muss zwischen {1} und {2} sein",
      "length": "muss aus {1} Zeichen bestehen",
      "minLength": "muss mindestens {1} Zeichen lang sein",
      "maxLength": "darf höchstens {1} Zeichen lang sein",
      "rangeLength": "muss zwischen {1} und {2} Zeichen lang sein",
      "oneOf": "muss bestehen aus: {1}",
      "equalTo": "muss das Gleiche sein wie {1}",
      "digits": "darf nur Ziffern enthalten",
      "number": "muss eine Zahl sein",
      "url": "muss eine gültige URL sein",
      "inlinePattern": "ist ungültig",
      "matchPasswords": "Passwörter stimmen nicht überein",
      "matchEmail": "E-Mail-Adressen stimmen nicht überein.",
      "compareWithOriginalEmail": "Neue E-Mail-Adresse darf nicht identisch mit der aktuellen sein."
    }
  },
  "errors": {
    "messages": {
      "already_confirmed": "Ihr Account wurde bereits bestätigt, bitte versuchen Sie, sich anzumelden.",
      "prohibited": {
        "ownership": {
          "one": "1 Fehler verhindert, dass das Benutzerrecht für dieses Gerät gespeichert wird:",
          "others": "2 Fehler verhindern, dass das Benutzerrecht für dieses Gerät gespeichert wird: …dass das Gerät gespeichert wird"
        }
      }
    }
  },
  "passwordWrong": "Das aktuelle Passwort ist falsch. Bitte überprüfen Sie Ihre Eingabe!",
  "ownership": {
    "invalidToken": "Ungültiger Zugangscode / Token",
    "alreadyClaimed": "Das Gerät wurde bereits hinzugefügt.",
    "successfully": {
      "created": "Das Gerät wurde erfolgreich aktualisiert.",
      "deleted": "Das Gerät wurde erfolgreich gelöscht!"
    },
    "alreadyInOwnAccount": "Dieses Gerät war bereits in Ihrem Account vorhanden. Wenn Sie es wiederherstellen möchten, wählen Sie das gewünschte Gerät aus der Liste aus.<br>Möchten Sie das Gerät als Neues Gerät hinzufügen, werden keine vorherigen Daten wiederhergestellt!",
    "alreadyInOtherAccount": "Dieses Gerät wurde bereits zu einem Account hinzugefügt!<br>Das Gerät muss aus allen anderen Accounts gelöscht  oder, sofern das Gerät in Ihrem Besitz ist, zurückgesetzt werden.<br>Bitte beachten Sie dazu die Hinweise in der Bedienungsanleitung!",
    "restoreThisDevice": "Dieses Gerät wiederherstellen",
    "deleteOwnership": "Gerät löschen",
    "addAsNew": "Als Neues Gerät hinzufügen",
    "confirmText": "Sind Sie sicher, dass Sie das Gerät löschen möchten? ",
    "claim": {
      "online": {
        "message": "Um ein Gerät hinzufügen zu können, muss Ihr Kommunikationsmodul mit dem Internet verbunden sein."
      }
    },
    "via_tag": "Via-Kennung",
    "editing": "Gerät bearbeiten",
    "description": {
      "via_tag": "Geben Sie eine Via-Kennung ein und speichern Sie diese, um Ihre Via-Adresse zu personalisieren. Wenn die Via-Kennung gespeichert wurde, können Sie mit Ihrer Via-Adresse im Internet auf Ihr System zugreifen.<br/>Die Via-Kennung muss aus mindestens 3 Zeichen bestehen und muss mit einem Kleinbuchstaben beginnen. Sie darf Kleinbuchstaben, Zahlen und Bindestriche enthalten."
    },
    "claimedSuccessful": "Ihr __PRODUCT-NAME__ wurde erfolgreich hinzugefügt.",
    "getFirstDataHeader": "Datenabfrage läuft…",
    "getFirstDataSubtext": "Verbindung wird aufgebaut. Dieser Vorgang kann einige Minuten dauern...",
    "dataReceivedSuccessfully": "Daten erfolgreich abgerufen",
    "initSettingsText": "Bitte geben Sie die folgenden Informationen zu Ihrem Gerät an:",
    "claimOwnFriendshipToken": "Sie können nicht Ihren selbst erstellten Zugangscode verwenden!",
    "adjustTimestamps": "Zeitstempel anpassen",
    "adjustTimestampsInfo": "Mit dieser Option erhalten Ihre Live-Daten immer einen aktuellen Zeitstempel, auch wenn auf Ihrem Gerät (KM2) eine andere Uhrzeit eingestellt ist. Aktivieren Sie diese Option nur, wenn Sie Probleme mit der Aktualität Ihrer Daten haben und Kurvenverläufe im Diagramm ungeordnet dargestellt werden.",
    "openSettings": "Geräteeinstellungen öffnen"
  },
  "viatag": {
    "alreadyInUse": "Diese Via-Kennung wird bereits verwendet!"
  },
  "demo": {
    "temperature": {
      "collector": "Kollektortemperatur",
      "storage": {
        "below": "Speichertemperatur (unten)",
        "above": "Speichertemperatur (oben)"
      }
    },
    "pump": {
      "speed": "Drehzahl der Solarpumpe"
    },
    "valve": {
      "storage": "Speicherventil"
    },
    "maximum": {
      "count": {
        "exeed": "Demo-Datalogger konnte nicht eingerichtet werden. Jeder Benutzer darf maximal einen Demo-Datalogger hinzufügen."
      }
    }
  },
  "error": {
    "messages": {
      "not_found": "Nicht vorhanden"
    },
    "noData": {
      "aviable": "Für die gewählten Einstellungen stehen keine Daten zur Verfügung!"
    },
    "tooManyRequests": "Zu viele Anfragen. Bitte versuchen Sie es später noch einmal."
  },
  "coupon": {
    "claimedSuccessful": "Ihr Coupon wurde erfolgreich eingelöst. Ihr Fachpartner-Zugang wurde freigeschaltet / verlängert um:",
    "alreadyClaimed": "Coupon wurde bereits verwendet",
    "invalidToken": "Couponcode ungültig",
    "youHaveACoupon": "Sie haben einen Coupon?",
    "code": "Couponcode",
    "redeemCoupon": "Coupon einlösen",
    "name": "Coupon",
    "enterCouponCode": "Couponcode hier eingeben",
    "redeemAnotherCoupon": "Weiteren Coupon einlösen",
    "deviceWithTestPro": "Ihr neues Gerät verfügt über einen Coupon - DVM-Cloud-Service-Fachpartner-Zugang 30 Tage kostenlos testen!",
    "redeemNow": "Jetzt einlösen",
    "redeemLater": "Später einlösen",
    "redeemLaterText": "Sie können Ihren Coupon auch später einlösen - Ihr Code lautet: __COUPON__  (dieser befindet sich auch auf der Rückseite der Bedienungsanleitung)."
  },
  "device": {
    "notFound": "Gerät wurde nicht gefunden.",
    "newFirmwareAvailable": "Eine neue Firmware-Version __VERSION__ ist verfügbar!",
    "serial": "Serial",
    "version": "Version",
    "build": "Build",
    "product": "Product",
    "fw_feed": "Fw feed",
    "firmware_feed": "Firmware feed",
    "newFirmware": "Neue Firmware verfügbar",
    "claimInfoPorts": "Bitte beachten Sie, dass Ihr Kommunikationsmodul (KM2) mit dem Internet verbunden sein und Zugriff auf DVM Cloud Service haben muss! Damit das Kommunikationsmodul auf DVM Cloud Service zugreifen kann, muss der Zugang zu den Ports 80 und 1194 / 1195 uneingeschränkt möglich sein.",
    "claimInfoLed": "Betriebskontroll-LED muss dauerhaft grün leuchten",
    "claimVbusActivated": "DVM Cloud Service muss aktiviert sein",
    "claimInfoNetwork": "muss im Menü Netzwerk angezeigt werden",
    "claimInfoNoVisualizationSettings": "Für dieses Gerät existieren keine Visualisierungseinstellungen."
  },
  "dataProtection": {
    "Einwilligung": "Datenschutzrechtliche Einwilligung",
    "EinwilligungWiderruf": "Sie können Ihre Einwilligung jederzeit per <span class=\"nobr\">E-Mail</span> an datenschutz@dvm-cloud.net widerrufen.",
    "EinwilligungText1": "Ich habe die URL_NUTZUNG sowie die URL_DATENSCHUTZ verstanden und akzeptiere diese."
  },
  "eula": {
    "acceptWarning": "Sie müssen zuerst unsere Endbenutzer- und Datenschutzvereinbarung akzeptieren, um fortfahren zu können.",
    "agb": "Nutzungsbedingungen",
    "privacyPolicy": "Datenschutzerklärung",
    "reaccept": "Wir haben unsere Endbenutzer- und Datenschutzvereinbarung geändert. Um fortfahren zu können, müssen Sie diese zuerst akzeptieren.",
    "name": "Endbenutzer- und Datenschutzvereinbarung",
    "acceptText": "Indem Sie auf Registrieren klicken, erklären Sie sich mit unserer __eula__ einverstanden."
  },
  "filter": {
    "add": "neuen Filter hinzufügen",
    "showAll": "Alle anzeigen",
    "edit": "Filter bearbeiten",
    "name": "Filtername",
    "addToFilter": "Zum Filter hinzufügen",
    "show": "anzeigen",
    "mustBeAString": "Muss ein Text sein",
    "atLeastOneDatapoint": "Sie müssen mindestens ein Datenfeld zum Filter hinzufügen!",
    "showUsed": "nur bearbeitete Standardvorgaben",
    "pleaseSelectDatapoints": "Bitte wählen Sie Datenpunkte aus der Liste Ihrer Live-Daten aus.",
    "noFilterData": "Keine Filterdaten vorhanden!",
    "changedLiveData": "Ihre Live-Daten haben sich seit der Erstellung des Filters verändert!",
    "noConversionAvailable": "Keine Umrechnung vorhanden",
    "conversionError": "Fehler in der Konvertierung!",
    "changedLiveDataShowOldValues": "{1} Filterwerte sind nicht mehr in Ihren Live-Daten vorhanden und können nicht mehr bearbeitet werden!",
    "maxValues": "Es sind maximal {1} Filterwerte erlaubt!",
    "datapointNotEditable": "Sie können diesen Datenpunkt nicht bearbeiten!"
  },
  "day": {
    "today": "heute",
    "yesterday": "gestern",
    "lastTwo": "Letzte 2 Tage",
    "lastSeven": "letzte 7 Tage",
    "lastThirty": "letzte 30 Tage",
    "currentMonth": "Aktueller Monat",
    "lastMonth": "Vormonat",
    "sa": "Sa",
    "So": "So",
    "do": "Do",
    "Di": "Di",
    "Mi": "Mi"
  },
  "ademe": {
    "module": "Modul",
    "filter": {
      "header": "nach Modulen filtern",
      "units": "nach Einheiten filtern",
      "allModules": "Alle Module",
      "allUnits": "Alle Einheiten"
    },
    "report": {
      "add": "Neuen Report hinzufügen",
      "edit": "Report bearbeiten",
      "save": "Report speichern"
    },
    "add": {
      "header": "ADEME:"
    },
    "systemType": "Systemtyp",
    "systemNumber": "Systemnummer",
    "value": "Wert",
    "values": "Werte",
    "error": {
      "systemNumberStart": "Die Systemnummer muss mit IS starten!",
      "systemNumberLength": "Die Systemnummer muss eine Länge zwischen 12 und 14 Zeichen haben!",
      "systemNumberCharacter": "Die Systemnummer enthält ungültige Zeichen!",
      "systemNumberYear": "Die Systemnummer enthält kein gültiges Jahr!",
      "SystemType": "<br />Bitte wählen Sie einen Systemtyp aus!"
    },
    "hint": {
      "successSaveHeader": "Erfolgreich!",
      "successSaveBody": "Ihre Daten wurden erfolgreich gespeichert!",
      "warningSaveHeader": "Warnung!",
      "warningSaveBody": "Sie haben bereits Daten zu diesem System gespeichert, Änderungen haben möglicherweise Auswirkungen auf ihre ADEME-Förderung!"
    },
    "select": {
      "systemType": "Systemtyp auswählen"
    },
    "system": "System",
    "units": {
      "Energy": "Energie",
      "Temperature": "Temperatur",
      "CubicMeter": "Kubikmeter"
    }
  },
  "sideBar": {
    "filters": "Filter",
    "images": "Bilder",
    "liveSchemes": "Live-Systeme",
    "diagrams": "Diagramme",
    "downloads": "Downloads",
    "reports": "Reporte",
    "notifications": "Benachrichtigungen",
    "visualization": "Visualisierung",
    "friends": "Gerät teilen",
    "dashboard": "Dashboard",
    "parametrization": "WebRPT-Parametrisierung",
    "discovery": "DeviceDiscoveryTool",
    "utilities": "Hilfsprogramme",
    "myVBusNet": "Mein Cloud Service",
    "status": "Status",
    "ademe": "ADEME",
    "monitoring": "Überwachung"
  },
  "choose": {
    "download": {
      "format": "Bitte ein Download-Format auswählen"
    },
    "system": "Bitte ein System auswählen",
    "background": {
      "image": "Bitte ein Hintergrundbild auswählen"
    },
    "filter": "Bitte eine Datenauswahl treffen",
    "periodOfTime": "Bitte einen Zeitraum auswählen",
    "image": "Bild auswählen",
    "device": "Gerät auswählen"
  },
  "plan": {
    "valid": {
      "until": "Gültig bis"
    },
    "order": {
      "here": "Bestellen Sie hier"
    },
    "days": {
      "left": "Verbleibende Tage"
    },
    "trial": {
      "expired": "TESTPHASE ABGELAUFEN"
    }
  },
  "subtitle": {
    "myDevices": "Meine Geräte",
    "myVirtualDevices": "Meine virtuellen Geräte"
  },
  "unit": {
    "add": "+ Wert addieren",
    "sub": "- Wert subtrahieren",
    "mul": "* Wert multiplizieren",
    "div": "/ Wert dividieren",
    "inv": "1 / Wert (Kehrwert)",
    "calculate": "Einheit umrechnen"
  },
  "parameterization": {
    "supportedDevicesText": "Folgende Geräte können aktuell mittels DVM Cloud Service parametrisiert werden:",
    "rptWebseite": "Falls Ihr Gerät noch nicht von VBus.net unterstützt wird, können Sie alternativ auch unser RESOL Parametrisierungstool RPT benutzen. Weitere Informationen zum RPT finden Sie auf unserer Webseite:",
    "connectionRptServer": "Verbindung zum WebRPT-Server wird hergestellt...",
    "connectionRptServerError": "Es konnte keine Verbindung zum WebRPT-Server hergestellt werden!",
    "connectionRptServerRetry": "Verbindung erneut prüfen...",
    "checkConncectionToDevice": "Parametrisierbarkeit prüfen",
    "notParameterizable": "Nicht parametrisierbar",
    "vbusPassword": "VBus-Passwort",
    "passwordHint": "Passwort zur Fernwartung (Werkseinstellung: vbus) eingeben.",
    "loadConfig": "Gespeicherte Konfigurationen laden:",
    "pleaseEnterVbusPassword": "Bitte VBus-Passwort eingeben und auf WEITER klicken.",
    "dataTransmission": "Datenübertragung läuft...",
    "configurationNotLoadable": "Konfiguration nicht ladbar!",
    "deleteConfiguration": "Soll diese Konfiguration gelöscht werden?",
    "errorTimeout": "Zeitüberschreitung bei Verbindung mit Kommunikationsmodul",
    "errorConnection": "Kommunikationsmodul nicht mit DVM Cloud Service verbunden",
    "errorNetwork": "Bitte überprüfen Sie Ihre Netzwerk-Verkabelung und / oder Kommunikationsmodul",
    "wrongVbusPassword": "Falsches VBus-Passwort!",
    "errorNoResponse": "Der Regler antwortet nicht!",
    "errorVbus": "Bitte überprüfen Sie die VBus-Leitung und / oder den Regler.",
    "errorCode": "Fehlercode",
    "errorLogin": "WebRPT-Login abgelaufen!",
    "login": "Bitte loggen sich erneut ein!",
    "notParametrizable": " ist nicht parametrisierbar.",
    "changedController": "Der Regler hat sich geändert!",
    "withoutConfiguration": "Ohne Konfiguration starten",
    "brokenConfiguration": "Defekte Konfiguration",
    "proRequired": "Fachpartner-Zugang erforderlich!",
    "rpt": "RPT-Hinweis",
    "start": "Jetzt parametrisieren",
    "connectionController": "Verbindung zum Regler wird hergestellt…",
    "noConnectionVBusnet": "Die Verbindung zu DVM Cloud Service konnte nicht hergestellt werden!",
    "checkStep1": "Bitte überprüfen Sie Ihr KM2 und gegebenenfalls dessen Netzwerkeinstellungen sowie Ihre Internet- und Firewall-Einstellungen.",
    "noConnectionController": "Die Verbindung zum Regler konnte nicht hergestellt werden!",
    "checkStep2": "Bitte überprüfen Sie, ob der Regler bereit und die VBus-Leitung korrekt angeschlossen ist.",
    "wrongPassword": "Ungültiges VBus-Passwort!",
    "checkStep3": "Bitte überprüfen Sie Ihre Eingabe und klicken Sie anschließend auf WEITER.",
    "controllerNotParameterizable": "Regler nicht parametrisierbar!",
    "checkStep4": "Bitte überprüfen Sie, ob Ihr Regler die Parametrisierung unterstützt.",
    "connectionVbusnet": "Verbindung zu DVM Cloud Service",
    "controller": "Regler",
    "checkVersion": "Versionsprüfung",
    "configurable": "Parametrisierbar?",
    "getSupportedDevices": "Unterstützte Geräte werden gesucht…",
    "foundSupportedDevices": "Es wurden folgende Geräte gefunden, die je nach Software-Version parametrisiert werden können:",
    "noSupportedDevices": "Keine unterstützten Geräte gefunden!",
    "configuration": "Konfiguration",
    "notAllowed": "Parametrisierung nicht erlaubt!"
  },
  "parametrization": {
    "header": "Parametrisierungstool RPT",
    "supportedDevices": "Folgende MTF-Regler werden unterstützt:",
    "subHeader": "Software zur Fernparametrisierung eines RESOL-Reglers",
    "downloadFree": "RPT-Software kostenlos herunterladen",
    "rptSoftware": "RPT-Software (Version 1.9)",
    "licenseNote": "License note",
    "manualPdf": "Anleitung (PDF)",
    "systemRequirements": "Systemvoraussetzungen: Windows 7, im Kompatibilitätsmodus Windows 8.1/10, Java 32 bit ab Version 1.6",
    "howToStepOne": "Starten Sie die RPT-Software auf Ihrem PC, dann wählen Sie <strong>Verbinden...</strong> im Menü <strong>Kommunikation</strong>.",
    "howToStepTwo": "Wählen Sie das verwendete Gerät aus und geben Sie Ihre Via-Kennung in das Feld <strong>URL/IP Adresse</strong> ein.",
    "howToStepThree": "Die Via-Kennung finden Sie auf der Seite",
    "howToStepFour": "Geben Sie Ihr Passwort ein. Wenn Sie Ihr Passwort noch nicht geändert haben, lautet es <strong>vbus</strong>.",
    "howToStepFive": "Klicken Sie auf <strong>Verbinden</strong>. Die Parametrisierung steht Ihnen nun zur Verfügung.",
    "deviceNotListed": "Sollte Ihr Regler nicht aufgeführt sein, nutzen Sie bitte die",
    "rscSoftware": "RSC-Software",
    "requiredDevices": "Um das Parametrisierungstool RPT über VBus.net nutzen zu können, benötigen Sie folgende RESOL-Geräte:",
    "youNeedDevice": "Sie verfügen noch nicht über ein RESOL-Gerät? Klicken Sie <a href=\"http://www.resol.de/\" target=\"_blank\">hier</a>, um auf unsere Internetseite zu gelangen."
  },
  "settingsDocumentation": {
    "errorTryAgain": "Bitte versuchen Sie es später noch einmal. Wenn  das Problem weiterhin besteht, kontaktieren Sie bitte das RESOL-Supportteam: support@resol.de",
    "description": "Der Settings Documentation Generator erstellt eine Dokumentation (PDF) aus Ihrer SET-Datei.",
    "selectSetFile": "SET-Datei auswählen",
    "documentTitle": "Dokumententitel",
    "convertSetFile": "SET-Datei konvertieren",
    "startConversion": "Konvertierung starten",
    "downloadPdfFile": "PDF-Datei herunterladen",
    "settingsDocumentationGenerator": "Settings Documentation Generator",
    "optionalTitel": "Optionaler Titel",
    "invalidSetFile": "Ungültiges SET-Dateiformat",
    "incompatibleSetFile": "Die Datei ist keine mit dem MTF-HKR-S kompatible SET-Datei. Bitte eine andere Datei auswählen.",
    "convertionFailed": "Konvertierung fehlgeschlagen",
    "errorConversionTookToLong": "Es hat zu lange gedauert, die Konvertierung abzuschließen.",
    "converting": "Konvertiere",
    "errorAllowedCharacters": "Nur Buchstaben, Zahlen, Bindestriche (-), Leerzeichen ( ) und Unterstriche (_) sind sind im Titel erlaubt.",
    "pdfFile": "PDF-Datei"
  },
  "passwordSame": "Das neue Passwort ist identisch mit dem aktuellen Passwort!",
  "delete": {
    "entry": {
      "text": "Dieser Eintrag kann nicht gelöscht werden, da er in den folgenden Funktionen verknüpft ist:",
      "header": "Eintrag löschen",
      "question": "Wollen Sie wirklich den Eintrag '<span id='myModalName' class='delete_question'></span>' löschen ?"
    }
  },
  "unitFamily": {
    "temperature": "Temperatur",
    "volume": "Volumen",
    "pressure": "Druck",
    "power": "Leistung",
    "energy": "Energie",
    "volumeFlow": "Volumenstrom",
    "time": "Zeit"
  },
  "deleteAccount": "Alle Ihre Daten sowie Ihr DVM-Cloud-Service-Zugang werden unwiderruflich gelöscht! Dieser Vorgang kann nicht rückgängig gemacht werden! Zur Bestätigung bitte das aktuelle Passwort eingeben.",
  "passwordRequired": "Bitte geben Sie Ihr aktuelles Passwort ein!",
  "yesDeleteAccount": "Ja, alle Daten löschen",
  "topBar": {
    "editProfile": "Mein Profil",
    "registerHere": "Jetzt kostenlos registrieren",
    "imprint": "Impressum",
    "register": "Registrieren",
    "home": "Home"
  },
  "passwordHackInfo": "IT-Spezialisten benötigen <b>TIME</b>, um dieses Passwort zu berechnen!",
  "changePasswort": {
    "noToken": "Es wurde kein gültiges Token zum Zurücksetzen des Passwortes gefunden! Bitte beachten Sie, dass das Zurücksetzen-Token nur 1 Tag gültig ist. Fordern Sie den Passwort-Zurücksetzen-Link gegebenenfalls erneut an."
  },
  "twoFactorTokenAlredyExists": "Die Wiederherstellungscodes lassen sich nur einmalig erstellen.",
  "dataviewer": {
    "title": "Zur Visualisierung von Systemdaten via SD-Karte. Die Daten werden in einem anschaulichen Verlaufsdiagramm dargestellt. Sie benötigen kein Kommunikationsmodul. Der Regler selbst muss nicht mit dem Internet verbunden sein. Ihre Daten bleiben bei Ihnen - die Visualisierungen werden nicht gespeichert."
  },
  "diagram": {
    "add": "neues Diagramm hinzufügen",
    "allow": {
      "public": "Link zur Anzeige des Diagramms erzeugen"
    },
    "edit": "Diagram bearbeiten",
    "data": "Daten",
    "height": "Höhe",
    "width": "Breite",
    "noDataSelected": "Keine Daten ausgewählt.",
    "min": "Min",
    "max": "Max",
    "publicUrlCustomRangeWarning": "In öffentlichen Diagrammen ist die Auswahl <strong>eigener Zeitraum</strong> nicht verfügbar!"
  },
  "vbus": {
    "deactivateFilter": "Die VBus-Protokoll-Datei enthält alle Werte. Die Filterfunktion wird deaktiviert.",
    "net": "DVM Cloud Service "
  },
  "download": {
    "add": "neuen Download hinzufügen",
    "edit": "Download bearbeiten",
    "noDataForSelectedPeriod": "Für den ausgewählten Zeitraum stehen keine Daten zur Verfügung!",
    "forOtherOs": "Für ein anderes Betriebssystem herunterladen"
  },
  "tooltip": {
    "filter": {
      "standardvorgabe": "Sie können jeden Filter als Standardvorgabe speichern und als Vorlage für neue Filter verwenden. Pro Gerät können Sie eine Standardvorgabe erstellen."
    }
  },
  "default": {
    "filter": {
      "load": {
        "msg": "Standardvorgabe laden",
        "text": "Filter als Standardvorgabe laden"
      },
      "values": "Filter-Standardvorgaben",
      "exists": {
        "text": "Sie haben bereits Filter für dieses Gerät angelegt."
      },
      "default": {
        "text": "Möchten Sie einen Filter als Standardvorgabe benutzen?",
        "create": "Standardvorgaben für dieses System erstellen",
        "load1": "Standardvorgaben zur Liste hinzufügen",
        "load2": "Liste mit den Standardvorgaben anpassen",
        "load3": "Liste mit den Standardvorgaben anpassen und fehlende Werte ergänzen"
      }
    },
    "load": "Laden",
    "default": {
      "notexists": {
        "text": "Sie haben noch keine Standardvorgabe für dieses Gerät hinterlegt.",
        "text1": "Möchten sie jetzt eine Standardvorgabe für dieses Gerät hinterlegen?"
      },
      "create": {
        "text": "Standardvorgabe erstellen"
      }
    }
  },
  "heating": {
    "systems": "Heizungssysteme"
  },
  "solar": {
    "systems": "Solarsysteme",
    "collectors": "Kollektoren",
    "storages": "Speicher",
    "collector": "Kollektor",
    "system": "Solarsystem"
  },
  "image": {
    "add": "neues Bild hinzufügen",
    "name": "Name des Bildes",
    "validMimeType": "Das Bild muss vom Typ .jpg, .jpeg, .png oder .gif sein",
    "edit": "Bild bearbeiten",
    "maxFilesize": "max. Dateigröße",
    "delete": "Bild wirklich löschen?"
  },
  "scheme": {
    "allow": {
      "public": "Link zur Anzeige des Systems erzeugen"
    },
    "setDatapoints": "Datenpunkte positionieren",
    "add": "neues System hinzufügen",
    "edit": "System bearbeiten",
    "publicUrl": "Über einen öffentlichen Link erreichen Sie Ihr Live-System selbst dann, wenn Sie nicht auf DVM Cloud Service eingeloggt sind. Sie können diesen Link mit auch mit Personen teilen, die nicht selbst bei DVM Cloud Service registriert sind. Sie können diesen Link auch in Ihre eigene Webseite einbinden, um Ihr Live-System dort zu präsentieren. "
  },
  "reports": {
    "dotDayOfMonth": "Tag jedes Monats",
    "dotDay": ".Tag jeden",
    "dotMonth": ".Monats um"
  },
  "please": {
    "wait": "Bitte warten..."
  },
  "parameterizationsettings": {
    "translation": "Parametrisierungseinstellungen",
    "makeShureNotDefaultPasswordText": "Bitte stellen Sie sicher, dass das Parametrisierungs-Passwort im Web-Interface Ihres Gerätes nicht auf die Werkseinstellung 'vbus' gesetzt ist.",
    "changePasswordText": "Klicken Sie hier, um das Parametrisierungs-Passwort im Web-Interface Ihres Gerätes zu ändern:"
  },
  "claim": {
    "howToFindToken": "So finden Sie Ihren Zugangscode / Token"
  },
  "index": {
    "claimANewDevice": "Gerät hinzufügen",
    "editThisInformation": "Diese Information bearbeiten",
    "welcomeToVBusnet": "Willkommen bei DVM Cloud Service!",
    "youNotHaveADataloggerYet": "Sie haben noch kein Gerät? Klicken Sie hier, um Ihrem Benutzerkonto einen Demo-Datalogger hinzuzufügen...",
    "noVideo": "Kein Video? Probieren Sie diese Alternativen aus",
    "videoDownload": "Video-Download",
    "orOn": "oder auf",
    "ifYouDoNotHaveADataloggerYet": "Wenn Sie noch kein Gerät haben, aber VBus.net gern ausprobieren möchten, können Sie Ihrem Benutzerkonto einen Demo-Datalogger hinzufügen, indem Sie die folgenden Schritte ausführen",
    "list": {
      "logInToVBusNet": "Bei DVM Cloud Service einloggen",
      "addADemonstationLogger": "Einen Demo-Datalogger zu Ihrem Benutzerkonto hinzufügen",
      "activateOptionDatalogger": "Option im Gerät aktivieren",
      "getActivationToken": "Zugangscode / Token beziehen",
      "claimLoggerWhithToken": "Zugangscode / Token eingeben, um das Gerät hinzuzufügen."
    },
    "download": {
      "datasheet": "Hier das VBus.net-<br />Datenblatt herunterladen!",
      "manual": "Hier die VBus.net-<br />Anleitung herunterladen!"
    },
    "text1": "DVM Cloud Service ist ein Internetangebot von <a href=“http://www.resol.de“>RESOL</a>, das Ihnen erlaubt, von überall in der Welt mit nur wenigen Klicks auf Ihr MTF-Gerät zuzugreifen.",
    "text3": "Bei DVM Cloud Service dreht sich alles um die Daten von Ihrem MTF-Regler. Um aber Zugang zu diesen Daten zu erhalten, müssen Sie Ihr Gerät anmelden. Sie können das in vier einfachen Schritten tun:",
    "noVideoPlaybackText": "Ihr Browser unterstützt keine Video-Ausgabe, bitte laden Sie das Video herunter.",
    "general": {
      "register": "Testen Sie kostenlos und unverbindlich"
    },
    "howto": {
      "question": "Sie möchten wissen wie es geht?"
    },
    "customer": {
      "examples": "Sie möchten sehen wie unsere Kunden DVM Cloud Service nutzen?"
    },
    "title": "Visualisieren Sie Ihre Anlagendaten",
    "text2": "Gratis Temperaturverläufe visualisieren, individuelle Live-Systeme und Diagramme erstellen.",
    "liveSystemExample": "Beispiel eines mit DVM Cloud Service erstellten Live-Systems.",
    "createNewVirtualDevice": "Virtuelles Gerät erstellen"
  },
  "show": {
    "liveData": "Live-Daten anzeigen"
  },
  "friendship": {
    "createToken": "Zugangscode / Token erstellen",
    "createdFriendships": "Erteilte Zugangscodes / Token",
    "createAccessTokenText": "<b>Teilen Sie Ihre Daten mit anderen DVM-Cloud-Service-Nutzern...</b><br/><br>Erstellen Sie einen neuen Zugangscode / Token für einen DVM-Cloud-Service-Nutzer, um ihm Zugang zu Ihren Daten zu gewähren. Hiermit kann dieser Nutzer eigene Visualisierungen basierend auf Ihren Daten erstellen. <br/><br/>Er kann diesen Zugangscode als neues Gerät in seinem DVM-Cloud-Service-Konto unter <b>Meine Geräte <i class=\"fa fa-angle-right\"></i> Gerät hinzufügen</b> hinzufügen. Teilen Sie ihm einfach den Zugangscode mit.<br/><br/> Selbstverständlich haben Sie die Möglichkeit, dieses Zugangsrecht wieder zu entziehen.",
    "featureNotAvailable": "Diese Funktion ist für ein Freundschaftsgerät nicht verfügbar!"
  },
  "feedbackForm": {
    "thankYou": "Vielen Dank für Ihr Feedback.",
    "yourOpinion": "Ihre Meinung ist uns wichtig!",
    "helpText": "Sie möchten zur Verbesserung von DVM Cloud Service beitragen oder uns Ihre Ideen, Wünsche und Anregungen mitteilen? Dann nutzen Sie einfach unser Feedback-Formular.",
    "assessmentText": "Beurteilen Sie bitte folgende Punkte:",
    "scopeOfFunctions": "Funktionsumfang",
    "userFriendliness": "Benutzerfreundlichkeit",
    "use": "Nutzen",
    "response": "Ihr Feedback wird unter der Nummer _ID_ bearbeitet.",
    "yourSatisfaction": "Ihre Zufriedenheit"
  },
  "imprint": {
    "chief": "Vertretungsberechtigter Geschäftsführer",
    "court": "Registergericht",
    "registration": {
      "number": "Registernummer"
    },
    "vat": "Umsatzsteuer-Identifikationsnummer gemäß § 27 a",
    "poweredBy": "Powered by",
    "technic": {
      "design": "Internet-Technik & -Design"
    }
  },
  "sales": {
    "tax": {
      "act": "Umsatzsteuergesetz"
    }
  },
  "howto": {
    "vbusdotnet": "Mit DVM Cloud Service können Sie Live-Daten Ihres Systems anzeigen. Außerdem können Sie für definierte Zeiträume Diagramme aus den gespeicherten Daten erstellen oder herunterladen.",
    "storageDuration": "Ihre Daten werden für 90 Tage (Basic) oder 1 Jahr (PRO) gespeichert.",
    "liveData": "Zeigt die Live-Daten Ihres Systems an.",
    "filter": "Erstellen Sie eine Auswahl Ihrer Datenpunkte für den weiteren Gebrauch in den Downloads, Live-Systemen und Diagrammen. Sie können die Datenpunkte umbenennen und eine individuelle Farbe für die Diagrammlinie wählen.",
    "images": "Speichern Sie Bilder für die Anzeige in den Live-Systemen. Sie können ein Bild aus der Auswahl wählen oder Ihre eigenen Bilder hochladen.",
    "downloads": "Laden Sie die gespeicherten Daten Ihres Systems für einen bestimmten Zeitraum herunter. Sie können Downloads für einen späteren Gebrauch speichern oder die Daten direkt herunterladen.",
    "liveSchemes": "Stellen Sie Ihre Live-Daten in einem Systembild dar. Sie können jeden einzelnen Datenpunkt mittels Ziehen und Loslassen (Drag&Drop) mit der Maus an die gewünschte Position innerhalb des Systembildes bewegen. Die Speicherung geschieht hierbei automatisch, sobald Sie den Datenpunkt platzieren. ",
    "diagrams": "Stellen Sie Ihre gespeicherten Daten in einem Diagramm über einen definierten Zeitraum dar. Hierzu benötigen sie einen zuvor erstellten Filter (siehe oben).",
    "question": "So funktioniert's",
    "friends": "Teilen Sie Ihr Gerät, um anderen DVM-Cloud-Service-Nutzern Zugriff auf Ihr System zu gewähren. Somit können die Nutzer, mit denen Sie Ihr Gerät teilen, eigene Diagramme, Live-Systeme usw. erstellen.",
    "monitoringGeneral": "Mit der DVM-Cloud-Service-Überwachung haben sie Zugriff auf das Fehlerprotokoll, in dem aufgetretene Fehler automatisch protokolliert werden sowie auf die Benachrichtigungen, mit denen Sie beliebige Parameter ihres Systems überwachen und sich per E-Mail informieren lassen können.",
    "monitoringNotification": "Mit den Benachrichtigungen können Sie verschiedene Systemparameter auswählen und überwachen. Sie können Grenzwerte festlegen und diese unter Verwendung diverser Kriterien mit den Live-Daten ihres Systems vergleichen. Wenn die Bedingungen für eine Benachrichtigung erfüllt sind, werden Sie per E-Mail informiert. Im Falle eines Verbindungsabbruchs erhalten Sie automatisch eine E-Mail-Benachrichtigung. Selbstverständlich werden Sie ebenfalls informiert, wenn die Verbindung zu ihrem System wiederhergestellt ist.",
    "monitoringErrorlog": "Das Fehlerprotokoll bietet eine Übersicht aufgetretener Fehler in Ihrem System. Dabei werden die Fehler mit Datum und Uhrzeit protokolliert und, sofern vom Regler unterstützt, das entsprechende Modul mit Sensor angegeben. Dies ist z. B. bei einer Fehlersuche sehr hilfreich.",
    "reports": "Erhalten Sie regelmäßig und automatisch die gespeicherten Daten ihres Systems per E-Mail. Sie können einen bestimmten Zeitraum auswählen und die Anzahl der Datenpunkte mit einem zuvor erstellen Filters beschränken (siehe oben). Ebenso können Sie weitere Empfänger für die geplanten Downloads festlegen.",
    "backup": "Erstellen Sie eine Sicherung all Ihrer Visualisierungseinstellungen.",
    "extendedReports": "Erhalten Sie regelmäßig Informationen über den Status Ihres Systems per E-Mail. Lassen Sie sich z. B. 1 x pro Woche über den Ertrag (als Diagramm), Fehlermeldungen usw. informieren.",
    "conversionsAndArithmeticOperations": "Umrechnungen und Rechenoperationen von Datenpunkten",
    "parametrization": "Parametrisieren Sie Ihren Regler ganz einfach mit Ihrem Browser. Speichern Sie Konfigurationen direkt in DVM Cloud Service und laden Sie diese bei Bedarf auf Ihren Regler."
  },
  "links": {
    "didNotReceiveConfirmationInstructions": "Sie haben keine Registrierungsbestätigung erhalten?",
    "didNotReceiveUnlockInstructions": "Sie haben keine Entsperrungs-Anweisungen erhalten?"
  },
  "customer": {
    "examples": "Kundenbeispiele"
  },
  "dashboard": {
    "proSubscriptionSchemeEditor": "Erweiterter System-Editor",
    "testProSubscription": "Testen Sie den DVM-Cloud-Service-Fachpartner-Zugang für 30 Tage kostenlos!",
    "proSubscriptionLiveData": "Minutengenaue Aktualisierung der Daten",
    "proSubscriptionWeatherDashboard": "Anzeige von Wetterinformationen im Dashboard",
    "proSubscriptionErrorLog": "Protokollierung von Fehlermeldungen Ihres Systems",
    "proSubscriptionReporting": "Individuell konfigurierbare Benachrichtigungen per E-Mail",
    "proSubscriptionFriendship": "Teilen von Zugriffsrechten z. B. mit Ihrem Installateur zu Informations- und Servicezwecken ",
    "proSubscriptionEnable": "Ja, ich möchte den Fachpartner-Zugang testen",
    "proSubscriptionDoNotRemember": "Nein, nicht mehr erinnern",
    "textClaimDemoQuestion": "Sie besitzen noch kein Kommunikationsmodul?",
    "textClaimDemo1": "Sie möchten sich aber trotzem jetzt schon über die Möglichkeiten von DVM Cloud Service informieren?",
    "textClaimDemo2": "Dann fügen Sie Ihrem Account einen Demo-Datalogger zum Testen hinzu.",
    "claimDemo": "Jetzt Demo-Datalogger hinzufügen",
    "textClaimOwnQuestion": "Sie besitzen bereits ein Kommunikationsmodul?",
    "textClaimOwn1": "Dann fügen Sie Ihrem Account Ihr eigenes Gerät hinzu.",
    "claimOwn": "Jetzt eigenes Gerät hinzufügen",
    "noDiagramAvailable": "Sie müsssen zuerst mindestens ein Diagramm erstellen, um dieses im Dashboard anzuzeigen.",
    "noLiveSystemAvailable": "Sie müsssen zuerst mindestens ein Live-System erstellen, um dieses im Dashboard anzuzeigen.",
    "noWeatherAvailable": "Sie müssen zunächst einen Standort für ein Gerät hinterlegen, um diesen im Dashbord anzuzeigen.",
    "demoVisualisierung": "Demo-Visualisierung",
    "ownVisualisierung": "Eigenes Gerät visualisieren",
    "chooseComponent": "Wählen Sie eine Dashboard-Komponente",
    "addComponent": "Neue Komponente hinzufügen",
    "editComponent": "Komponente bearbeiten",
    "changeBackgroundColor": "Hintergrundfarbe ändern",
    "deleteAllComponents": "Alle Komponenten löschen",
    "addComponentInfo": "Fügen Sie neue Komponenten zu Ihrem Dashboard hinzu",
    "notAvailableInFullscreen": "Nicht verfügbar im Vollbildmodus!",
    "reloadComponent": "Komponente neu laden",
    "deleteSelectedComponents": "Ausgewählte Komponenten löschen",
    "deselectAll": "Alle abwählen",
    "noImageAvailable": "Sie müssen zuerst mindestens ein Bild erstellen, um dieses im Dashboard anzuzeigen.",
    "notAllowedForSubscription": "Dieser Inhalt ist für Ihren Zugang nicht oder nicht mehr verfügbar!",
    "removeThisComponent": "Möchten Sie diese Komponente vom Dashboard entfernen?",
    "removeSelectedComponents": "Möchten Sie die ausgewählten Komponenten vom Dashboard entfernen?",
    "load": "Dashboard laden",
    "loadFromOtherDevice": "Dashboard von anderem Gerät laden",
    "loadFromOtherDeviceInfo": "Sie können die Dashboard-Einstellungen von einem anderen Gerät laden und bearbeiten. Die Änderungen haben keine Auswirkung auf das Dashboard des anderen Gerätes.",
    "settings": "Dashboard-Einstellungen",
    "itemBorderTyp": "Rahmen-Typ",
    "itemBorderNone": "Ohne",
    "itemBorder": "Rahmen",
    "itemBorderShadow": "Schatten",
    "lockItems": "Komponenten sperren",
    "deleteQuestion": "Dashboard löschen?",
    "delete": "Dashboard löschen"
  },
  "images": {
    "clickOnImageText": "Einfach auf das gewünschte Bild klicken.",
    "currentImage": "Aktuelles Bild"
  },
  "enter": {
    "name": {
      "diagram": "Bitte einen Namen für das Diagramm eingeben",
      "filter": "Bitte einen Namen für den Filter eingeben",
      "scheme": "Bitte geben Sie einen Namen ein",
      "image": "Bitte einen Namen für das Bild eingeben"
    },
    "vbus": {
      "password": "Bitte VBus-Passwort eingeben und auf WEITER klicken…"
    }
  },
  "prepare": {
    "download": "Ihr Download wird vorbereitet. Dies kann einige Zeit dauern. Bitte warten…"
  },
  "access": {
    "denied": "Zutritt verweigert"
  },
  "data": {
    "filter": "Filter",
    "transmission": {
      "running": "Datenübertragung läuft…"
    }
  },
  "genral": {
    "to": "bis"
  },
  "unselect": {
    "all": "nichts auswählen"
  },
  "my": {
    "account": "Mein Benutzerkonto",
    "diagrams": "Meine Diagramme",
    "downloads": "Meine Downloads",
    "schemes": "Meine Live-Daten",
    "devices": "Meine Geräte",
    "friends": "Nutzer mit Zugang zu meinen Geräten",
    "reports": "Meine Reporte"
  },
  "limitationText": {
    "noConfiguration": "Keine Konfiguration des Gerätes möglich",
    "only90days": "Nur gespeicherte Daten von 90 Tagen verfügbar",
    "onlyDemoDatalogger": "Zugang nur zum Demo-Datalogger"
  },
  "info": {
    "smallerLogInterval": "Im Datalogger eingestellte kleinere Logintervalle werden von VBus.net nicht unterstützt.",
    "logInterval": "DVM Cloud Service speichert die von Ihrem Kommunikationsmodul aufgezeichneten Daten in Intervallen von 5 Minuten oder größer.",
    "clickToDelete": "Löschen: <i class=\"fa fa-trash-o clickToDelete\"></i>",
    "clickToEdit": "Bearbeiten: <i class=\"fa fa-edit clickToEdit\"></i>",
    "clickToMove": "Verschieben: <i class=\"fa fa-arrows-v clickToMove\"></i>"
  },
  "modal": {
    "info": {
      "filter": "Wenn Sie eine personalisierte Auswahl an Daten angezeigt bekommen möchten, legen Sie zunächst einen <a class='link' href='/vbus/add-selector'>Filter</a> für Ihr System an. Sie können dann auch personalisierte Filter für die Datenanzeige auswählen."
    }
  },
  "discover": {
    "deviceDiscovery": "Device Discovery",
    "deviceDiscoveryWizard": "Device Discovery Wizard"
  },
  "unlocks": {
    "resendUnlockInstructions": "Bitte Entsperrungs-Anweisungen erneut zusenden"
  },
  "activerecord": {
    "errors": {
      "models": {
        "ownership": {
          "attributes": {
            "name": {
              "too_short": " ist zu kurz (Minimum: 3 Zeichen)"
            }
          }
        }
      }
    }
  },
  "forward": {
    "toWebinterfaceOfDatalogger": "Sie werden zum Web-Interface des Gerätes weitergeleitet…",
    "notAllowedToAccessOwnership": "Sie haben keinen Zugriff auf dieses Gerät.",
    "textForwardedToWebInterface": "Wenn dies Ihr Gerät wäre, würden Sie in wenigen Augenblicken zu dessen Web-Interface weitergeleitet werden. Für den Demo-Datalogger steht dieses Feature nicht zur Verfügung. Vielen Dank für Ihr Verständnis.",
    "textLoginOtherCredentials": "Bitte denken Sie daran, dass die Login-Daten des Geräte-Web-Interface sich von denen des DVM-Cloud-Service-Kontos unterscheiden.",
    "textYouWillBeForwarded": "Sie werden in wenigen Augenblicken zum Web-Interface Ihres Gerätes weitergeleitet. Wenn Sie nicht automatisch weitergeleitet werden sollten, klicken Sie bitte auf den folgenden Link.",
    "datenloggerLink": "Geräte-Interface"
  },
  "paypal": {
    "buy": {
      "now": "Jetzt kaufen"
    },
    "order": {
      "text": "Bitte beachten Sie, dass die Bearbeitung einige Tage dauern kann.",
      "error": "Bei der Übermittlung der Daten an oder von Paypal ist ein Fehler aufgetreten. Bitte wenden Sie sich an unseren technischen Support, falls Ihre gekaufte Zusatzleistung nicht aktiviert wurde."
    }
  },
  "invalid": {
    "via_tag": "Die Via-Kennung muss aus mindestens 3 Zeichen bestehen und muss mit einem Kleinbuchstaben beginnen. Sie darf Kleinbuchstaben, Zahlen, Bindestriche und Unterstriche enthalten."
  },
  "incorrect": {
    "failure": {
      "already_activated": "Diese Via-Kennung kann nicht benutzt werden. Bitte wählen Sie eine andere."
    }
  },
  "selected": {
    "dataFields": "Ausgewählte Datenfelder"
  },
  "legend": {
    "description": "Legende",
    "layout": {
      "align": "Anordnung",
      "horizontal": "Horizontal",
      "vertical": "Vertical"
    },
    "position": {
      "horizontal": "Horizontale Position",
      "vertical": "Vertikale Position",
      "left": "Links",
      "central": "Mitte",
      "right": "Rechts",
      "top": "Oben",
      "bottom": "Unten"
    }
  },
  "datapoint": {
    "selectedOne": "ausgewählter Datenpunkt",
    "selectedMore": "ausgewählte Datenpunkte"
  },
  "information": {
    "minOneOwnership": "Um die Visualisierungs-Funktionen nutzen zu können, müssen Sie mindestens ein Gerät Ihrem Benutzerkonto hinzufügen."
  },
  "tip": {
    "location": "Wenn Sie einen Standort für Ihr Gerät hinterlegen, können Sie im Dashboard Wetterinformationen abrufen. Hinterlegen Sie die Geo-Koordinaten Ihres Systems oder suchen Sie einfach nach dem Standort."
  },
  "messages": {
    "tryGeodata": "Geben Sie Ihre Geo-Koordinaten direkt ein."
  },
  "get": {
    "professional": {
      "account": "Sichern Sie sich jetzt Ihren Fachpartner-Zugang..."
    }
  },
  "one": {
    "year": {
      "vbus": {
        "professional": "7 Jahre DVM-Cloud-Service-Fachpartner-Zugang"
      }
    }
  },
  "register": {
    "subscribe": {
      "newsletter": "Ich möchte den RESOL-Newsletter erhalten."
    },
    "free": "Jetzt kostenlos registrieren"
  },
  "homepage": {
    "greetingText": "Das Internetportal für den einfachen und sicheren Zugriff auf Ihre Systemdaten",
    "simpleText": "Einfacher Zugang in nur zwei Schritten:",
    "registerText": "Kostenlos auf DVM Cloud Service <a href=\"#register\">registrieren</a>",
    "addDataloggerText": "Ihr Gerät auf DVM Cloud Service hinzufügen",
    "initationText": "Bei DVM Cloud Service dreht sich alles um die Daten Ihres MTF-Reglers. Es erwarten Sie Live-Daten Ihres Systems, personalisierte Filtereinstellungen und vieles mehr.",
    "dataViewerHeader": "In VBus.net integriert - der VBus Data Viewer",
    "dataViewerInfo": "Auf der SD-Karte gespeicherte Daten im VBus Data Viewer ansehen"
  },
  "errorLog": {
    "thankYou": "Vielen Dank für die Einsendung Ihres Fehlerberichtes.",
    "ticketNumberText": "Ihr Ticket ist unter der folgenden Ticket-Nr. bei uns eingegangen:"
  },
  "rerrorReport": {
    "helpText": "Unterstützen Sie uns bei der Verbesserung von DVM Cloud Service, indem Sie uns eventuelle Fehlfunktionen mitteilen, die Ihnen beim Umgang mit DVM Cloud Service aufgefallen sind."
  },
  "friendshipToken": {
    "typeOfUse": "Verwendungszweck",
    "useText": "Geben Sie hier einen Namen ein, mit dem Sie den Zugangscode / Token im Nachhinein identifizieren können. Somit haben Sie einen Überblick, mit wem Sie Ihr Gerät geteilt haben."
  },
  "cookies": {
    "name": "Cookies",
    "useVBusnet": "Das Zulassen von Cookies ist Voraussetzung für die Nutzung des Angebots DVM Cloud Service.",
    "description1": "Bei Cookies handelt es sich um kleine Text-Dateien, die von einer Webseite auf Ihrem Computer gespeichert werden. Sie speichern Informationen zu Ihrem letzten Besuch, wie Ihre bevorzugte Sprache oder andere Einstellungen.",
    "description2": "DVM Cloud Service nutzt Cookies ausschließlich, um sich Ihre Spracheinstellung und Anmeldeinformationen zu merken.",
    "furtherInformation": "Weitere Informationen zu Cookies und deren Verwaltung finden Sie auf",
    "disclaimerExternalLinks": "Bitte beachten Sie, dass wir nicht für die Inhalte externer Webseiten verantwortlich sind.",
    "privacyPolicy": "Weitere Informationen zu Cookies und deren Verwendung finden Sie in unserer"
  },
  "subscribe": {
    "maintenance": "Ja, ich möchte über Wartungsarbeiten per E-Mail informiert werden."
  },
  "title": {
    "help": "Hilfe"
  },
  "original": {
    "names": "Original-Namen",
    "value": "Originalwert"
  },
  "cookie": {
    "acceptText": "Bestimmungen zu Cookies"
  },
  "viaTag": {
    "useDefaultPassword": "Ihr Gerät ist über das Standardpasswort erreichbar!",
    "ChangePasswordText": "Bitte ändern Sie aus Sicherheitsgründen das Passwort Ihres Gerätes."
  },
  "lineChart": {
    "diagram": "Liniendiagramm (absolut)"
  },
  "barChart": {
    "diagram": "Balkendiagramm (Tageszusammenfassung)"
  },
  "werbung": {
    "textDatenlogger": "Weitere Infos zu unseren Modulen?",
    "textKommunikationsmodul": "Haben Sie schon unser Kommunikationsmodul entdeckt?",
    "textSolarregler": "Kennen Sie schon die DeltaSol® Solar- und Systemregler?",
    "textHeizungsregler": "Möchten Sie mehr über unsere Heizungsregler-Familie erfahren?"
  },
  "notice": {
    "dataloggerTimeout": "Dieses Gerät liefert seit mehreren Minuten keine Live-Daten mehr...",
    "dataloggerInitialze": "Initialisierung",
    "dataloggerInitialzeText": "Es kann ein paar Minuten dauern bis Ihr Gerät initialisiert ist.",
    "dataloggerInitialzed": "Ihr Gerät ist nun initialisiert. Sie können jetzt mit der Visualisierung loslegen."
  },
  "nextStep": {
    "step2": "Wenn Sie ein <b>Live System</b> erstellen möchten, benötigen Sie zunächst ein __IMAGE__.",
    "step3": "Sie können jetzt ein __DIAGRAM__ oder ein __LIVESYSTEM__ erstellen.",
    "step4": "Erstellen Sie einen __DOWNLOAD__ Ihrer Daten, um diese manuell zu verarbeiten oder zu analysieren.",
    "step1": "Erstellen Sie zunächst einen __FILTER__, um ein <b>Diagramm</b> oder <b>Live System</b> zu erstellen.<br/>Ein <b>Download</b> lässt sich auch über einen Filter optimieren."
  },
  "support": {
    "noDatafromDevice": "Es konnten keine Daten von Ihrem Gerät empfangen werden!",
    "pleaseCheck": "Beachten Sie die Anleitung des Gerätes und prüfen Sie die folgenden Punkte: ",
    "checkPowerSupply": "Spannungsversorgung des Routers und des Kommunikationsmoduls",
    "checkInternetConnection": "Internetverbindung",
    "checkConncectionToDevice": "Verbindung vom Router zum Kommunikationsmodul",
    "checkManual": "Für weitere Informationen schauen Sie bitte in die Bedienungsanleitung Ihres Gerätes.",
    "hintIntranet": "Für Firmennetzwerke: Die Ports 1194 und 1195 werden von Ihrer Firewall geblockt. Bitte wenden Sie sich an Ihren Netzwerkadministrator.",
    "allowAccessToAccount": "Zugriff auf Ihren DVM-Cloud-Service-Zugang erlauben",
    "token": "Support-Token",
    "needHelp": "Sie benötigen Hilfe und möchten unserem Supportteam die Erlaubnis geben, auf Ihren DVM-Cloud-Service-Zugang zuzugreifen? Erstellen Sie hier einen Support-Token und teilen Sie diesen unserem Supportteam telefonisch mit.",
    "tokenRemove": "Support-Token löschen",
    "tokenCreate": "Support-Token erstellen",
    "extended": "Erweiterter Support"
  },
  "areaChart": {
    "diagram": "Flächendiagramm"
  },
  "userFeedback": {
    "helpUs": "Helfen Sie uns, DVM Cloud Service zu verbessern<br />und sichern Sie sich einen Fachpartner-Monat gratis!",
    "takeTheSurvey": "Hier an der Umfrage teilnehmen",
    "question1": "Wie bewerten Sie den Registrierungsvorgang von DVM Cloud Service?",
    "question2": "Wie bewerten Sie die Funktionserklärungen bzw. die Hilfsvideos?",
    "question3": "Wie bewerten Sie den allgemeinen Funktionsumfang von DVM Cloud Service?",
    "question4": "Wie schätzen Sie die Benutzerfreundlichkeit ein?",
    "question5": "Für wie praktisch und ansprechend halten Sie die Visualisierungen?",
    "question6": "Für wie nützlich halten Sie DVM Cloud Service?",
    "question7": "Werden Sie die Fachpartner-Version verlängern?",
    "question8": "Welche Gründe sprechen gegen die Nutzung der Fachpartner-Version?",
    "question9": "Wie häufig nutzen bzw. werden Sie DVM Cloud Service voraussichtlich nutzen?",
    "question10": "Welche Funktionen/Verbesserungen wünschen Sie sich für DVM Cloud Service?",
    "question11": "Welche Probleme sind bei Ihnen bzgl. DVM Cloud Service aufgetreten?",
    "question12": "Wie wahrscheinlich ist es, dass Sie DVM Cloud Service weiterempfehlen?",
    "question13": "Weitere Erfahrungen/Allgemeine Bemerkung?",
    "submit": "Feedback-Formular absenden",
    "simple": "Einfach",
    "complicated": "Kompliziert",
    "veryHelpful": "Sehr hilfreich",
    "redundant": "Überflüssig",
    "notUsed": "Wurde nicht genutzt",
    "excellent": "Hervorragend",
    "insufficient": "Unzureichend",
    "veryEasy": "Sehr einfach",
    "extremelyComplex": "Extrem komplex",
    "veryGood": "Sehr gut",
    "veryBad": "Sehr schlecht",
    "indispensable": "Unverzichtbar",
    "useless": "Unbrauchbar",
    "dontKnowYet": "Weiß noch nicht",
    "price": "Preis",
    "noAdditionalValue": "kein Mehrwert",
    "other": "Andere",
    "daily": "Täglich",
    "weekly": "1 - 3x wöchentlich",
    "monthly": "1 - 3x monatlich",
    "lessThanMonth": "weniger als 1x im Monat",
    "quietSure": "Zielmlich sicher",
    "certainlyNot": "Auf keinen Fall",
    "backToDashboard": "Zurück zum Dashboard",
    "answerAllQuestions": "Bitte beantworten Sie alle mit <i class=\"fa fa-times\" aria-hidden=\"true\"></i> markierten Fragen!",
    "extendedPro": "Ihr Fachpartner-Zugang wurde um 30 Tage verlängert."
  },
  "dashboardMessage": {
    "changeViaTag": "Aus technischen Gründen hat sich die Endung der Via-Kennung von <kbd>.via.vbus.net</kbd> auf <kbd>.vbus.io</kbd> geändert. Bitte passen Sie ggf. Ihre Lesezeichen entsprechend an.<br><br>(Beispiel: meindl2.via.vbus.net -> meindl2.vbus.io). Weitere Einstellungen Ihrerseits sind nicht notwendig."
  },
  "config": {
    "startWithout": "Ohne Konfiguration starten",
    "empty": "leer",
    "notLoadable": "nicht ladbar"
  },
  "check": {
    "completed": "Überprüfung abgeschlossen…"
  },
  "waiting": {
    "running": {
      "tasks": "Laufende Prozesse werden beendet..."
    }
  },
  "dsgvo": {
    "Nutzungsbedingungen": "Ich habe die <a href=\"#register\" class=\"open-terms-of-use\">Nutzungsbedingungen</a> gelesen, verstanden und akzeptiere diese.",
    "Datenschutzerklaerung": "Ich habe die <a href=\"#register\" class=\"open-privacy-policy\">Datenschutzerklärung</a> gelesen, verstanden und akzeptiere diese."
  },
  "pro": {
    "validUntil": "Fachpartner-Zugang gültig bis"
  },
  "channel": {
    "no": "Kanal-Nr."
  },
  "location": {
    "notFound": "Keinen Standort gefunden!"
  },
  "faq": {
    "q1": "Wie füge ich ein Gerät zu DVM Cloud Service hinzu?",
    "a1": "Melden Sie sich in DVM Cloud Service an.Den Menüpunkt Meine Geräte öffnen und Gerät hinzufügen anklicken. Den Zugangscode/Token von Ihrem Gerät eingeben.",
    "q2": "Wie erstelle ich einen Support-Report?",
    "a2_1": "Im Web-Interface des KM2 einloggen. Konfiguration -> Allgemein -> Expertenmodus aktivieren. Status -> Support-Report auf Download klicken.",
    "a2_2": "Die Datei speichern und an __EMAIL__ senden.",
    "a2_3": "Die IP-Adresse des Kommunikationsmoduls im Browser aufrufen und im Web-Interface einloggen.",
    "a2_4": "Die URL http://[IP DES GERÄTS]/dlx/support aufrufen",
    "a2_5": "Es erscheint der Link \"Hier klicken, um den Supportbericht zu erstellen und herunterzuladen“, mit dem der Download ausgeführt wird.",
    "q3": "Mein Gerät ist offline, was kann ich tun?",
    "a3": "Prüfen Sie, ob Ihr Gerät mit dem Internet verbunden ist. Sind eventuell andere Geräte im selben Netzwerk auch nicht mit dem Internet verbunden, kann ein Problem mit der Internetverbindung vorliegen. Damit das Gerät auf DVM Cloud Service zugreifen kann, muss der Zugang zu den Ports 80 und 1194 / 1195 uneingeschränkt möglich sein und darf nicht von einer Firewall blockiert werden.",
    "q4": "Muss ich für DVM Cloud Service bezahlen?",
    "a4": "VBus.net ist in der Basis-Version kostenlos. Sie können Ihr System visualisieren und erhalten alle 5 Minuten Live-Daten. Die PRO-Version kostet 39 € pro Jahr und bietet neben den Basis-Funktionen viele Möglichkeiten zur Überwachung und erweiterte Funktionen in der Visualisierung. Weiterhin ist die Parametrisierung über WebRPT enthalten und Ihre Live-Daten werden jede Minute aktualisiert.",
    "q5": "Was ist der Unterschied zwischen VBus.net Basic und PRO?",
    "a5": "Hier finden Sie einen Vergleich der unterschiedlichen VBus.net-Versionen: __VERSIONSVERGLEICH__",
    "q6": "Unterstützt VBus.net den Schnittstellenadapter VBus®/LAN?",
    "a6": "Nein, um Ihren Regler mit DVM Cloud Service  zu verbinden, ist ein Kommunikationsmodul KM2 erforderlich.",
    "q7": "Meine Diagramme werden falsch dargestellt, was kann ich tun?",
    "a7": "Bitte prüfen Sie, ob die eingestellte Zeitzone unter Meine Geräte richtig eingestellt ist und dem Standort des Gerätes entspricht. Prüfen Sie auch die Zeitzone auf dem Gerät selbst.",
    "q8": "Wie lautet das Passwort für die Parametrisierung?",
    "a8": "vbus",
    "title": "Antworten auf Ihre häufigsten Fragen",
    "hints": "Bitte achten Sie darauf, dass Sie immer einen aktuellen Browser verwenden. Sollten weiterhin Probleme auftreten, verwenden Sie einen anderen Browser.",
    "notFound": "Ihre Frage wurde noch nicht beantwortet? Dann kontaktieren Sie uns bitte unter __LINK__.",
    "q9": "In einem Diagramm befinden sich nicht verwendete Beschriftungen auf der Y-Achse.",
    "a9": "Der in diesem Diagramm verwendete Filter muss nochmals gespeichert werden.",
    "q10": "In meinem Live-System, Diagramm oder Download werden nicht alle Werte angezeigt.",
    "a10": "Kontrollieren Sie den zugehörigen Filter und speichern Sie diesen ggf. erneut.",
    "q11": "Warum funktioniert DVM Cloud Service auf meinem älteren Android-Gerät v2.x oder Smart-TV nicht mehr?",
    "a11": "DVM Cloud Service hat seine Sicherheitseinstellungen dem aktuellen Standard angepasst. Deshalb können ältere Geräte DVM Cloud Service nicht mehr aufrufen. Aktualisieren Sie Ihr Gerät, um DVM Cloud Service wieder nutzen zu können. Schauen Sie bei ihrem Gerätehersteller, ob es eine neue Software für ihr Gerät gibt."
  },
  "createImageFirst": "Sie müssen zuerst ein Bild erstellen…",
  "professinal": {
    "expiredOn": "Fachpartner-Zugang am __VALID_UNTIL__ abgelaufen!",
    "expireInfo": "Bitte beachten Sie, dass nach Ablauf des Fachpartner-Zugangs Dienste wie z. B. geplante Downloads, Reporte und Benachrichtigungen nicht mehr zur Verfügung stehen!"
  },
  "validation": {
    "positiveNumber": "positive Zahl"
  },
  "reset": {
    "allEntries": "Alle Einträge zurücksetzen"
  },
  "fileSizeToBig": "Die Datei ist zu groß!",
  "controllerVersionChanged": "Die Version Ihres Reglers hat sich geändert!",
  "cantLoadConfigurations": "Einige Konfigurationen können eventuell nicht mehr geladen werden, da sie von dieser Version nicht unterstützt werden.",
  "dl3NotSupported": "DL3 wird aktuell nicht unterstützt!",
  "change": {
    "modulename": "Modulnamen ändern"
  },
  "email": {
    "doNotReply": "Dies ist eine automatisch versendete E-Mail. Bitte antworten Sie nicht auf diese Nachricht, da die E-Mail-Adresse nicht zum Empfang von E-Mails eingerichtet ist."
  },
  "discoveryTool": {
    "title": "Device-Discovery-Tool",
    "text": "Das Device-Discovery-Tool sucht nach RESOL-Geräten im lokalen Netzwerk und bietet Diagnosefunktionen bei Verbindungsproblemen zu VBus.net."
  },
  "group": {
    "create": "Gruppe erstellen",
    "edit": "Gruppe bearbeiten",
    "delete": "Gruppe löschen",
    "deleteGroup": "Möchten Sie die Gruppe löschen?",
    "neDeviceDelete": "Die Geräte in der Gruppe werden dabei nicht gelöscht."
  },
  "filterValue": {
    "add": "Filterwert addieren",
    "sub": "Filterwert subtrahieren",
    "mul": "Filterwert multiplizieren",
    "div": "Filterwert dividieren",
    "conversionWithFilter": "Umrechnung mit Filterwert",
    "linkedTo": "Verwendet von"
  },
  "errorSendingEmails": "Wir konnten mehrfach keine E-Mails an einen oder mehrere Empfänger in den Diensten (Geplante Downloads, Reporte oder Benachrichtigungen) zustellen!",
  "errorSendingEmailConfirm": "Sind Sie sicher? Sie müssen die E-Mail-Adresse für jeden Dienst einzeln bestätigen!",
  "confirmEmailServices": "Meine E-Mail-Adresse in den Diensten (Geplante Downloads, Reporte oder Benachrichtigungen) erneut bestätigen.",
  "keyboard": {
    "capsLockActive": "Feststelltaste aktiv!"
  },
  "firmware": {
    "title": "MTF-Geräte-Firmware-Update",
    "available": "Die folgende Firmware ist für Ihr Gerät verfügbar",
    "downloadText": "Wenn Sie die Firmware inkl. des dazugehörenden Quellcodes herunterladen wollen, können Sie das über den folgenden Link tun",
    "deviceInstall": "Ihr Gerät wird das Update automatisch installieren.",
    "acceptText": "Ich habe die Hinweise zur Kenntnis genommen und möchte das automatische Update für diese Firmware aktivieren.",
    "alreadyAccepted": "Sie haben das automatische Update für diese Firmware bereits aktiviert.",
    "activateAutomaticUpdate": "automatisches Update aktivieren"
  }
}



// WEBPACK FOOTER //
// ./src/locales/mtf/de/index.js